// All new components must import useTranslation and use t() for UI strings
export const fr = {
  sidebar: {
    portfolio: "Portefeuille",
    projectList: "Projets",
    projectSchedule: "Calendrier des projets",
    directory: "Répertoire",
    invoiceInbox: "Boîte des factures",
    teamSchedule: "Horaire des équipes",
    backToProjectList: "Liste des projets",
    construction_cost: "Aperçu financier",
    contracts: "Contrats",
    changeOrders: "Avenants",
    extrasCredits: "Directives & Extras",
    expenses: "Dépenses",
    subInvoicing: "Factures reçues",
    clientInvoicing: "Facturation client",
    dailyLog: "Journal de chantier",
    portfolioProfitability: "Portefeuille",
    projectView: "Vue d\'ensemble",
    brain: "Brain",
    onx: "OnX",
    schedule: "Calendrier",
    documents: "Documents",
    rfi: "QRT",
    userFallback: "Utilisateur"
  },
  bulk: {
    selectedOne: "1 sélectionné",
    selected: "{count} sélectionnés",
    clear: "Effacer",
    clearTooltip: "Effacer la sélection",
    cancel: "Annuler",
    export: "Exporter",
    exportCsv: "Exporter CSV",
    exportPdf: "Exporter PDF",
    changeStatus: "Changer le statut",
    submit: "Soumettre",
    approve: "Approuver",
    reject: "Rejeter",
    draft: "Brouillon",
    delete: "Supprimer",
    archive: "Archiver",
    downloadPdf: "Télécharger le PDF",
    downloading: "Téléchargement…",
    scan: "Scanner",
    scanning: "Analyse de {count}…",
    createContract: "Créer le contrat"
  },
  common: {
    newProject: "Nouveau projet",
    cancel: "Annuler",
    confirm: "Confirmer",
    save: "Enregistrer",
    delete: "Supprimer",
    edit: "Modifier",
    add: "Ajouter",
    close: "Fermer",
    loading: "Chargement...",
    saving: "Enregistrement...",
    creating: "Création...",
    search: "Rechercher",
    reset: "Réinitialiser",
    clear: "Effacer",
    actions: "Actions",
    status: "Statut",
    noData: "Aucune donnée trouvée",
    na: "N/A",
    searchPlaceholder: "Rechercher…",
    searchOptions: "Rechercher une option…",
    searchProjects: "Rechercher un projet…",
    searchSubcontract: "Rechercher un sous-traitant…",
    selectPlaceholder: "Sélectionner…",
    selectAnOption: "Sélectionner une option",
    none: "Aucun",
    all: "Tous",
    unknownSubcontractor: "Sous-traitant inconnu",
    noResults: "Aucun résultat",
    noOptions: "Aucune option disponible",
    accessDenied: {
      banner: "Vous n\'avez pas accès à cette page. Contactez votre administrateur.",
      title: "Aucun accès",
      message: "Votre profil ne donne accès à aucune page. Contactez votre administrateur pour qu\'il vous attribue un gabarit de permissions.",
      backToList: "Retour à la liste des projets"
    }
  },
  userManagement: {
    pageTitle: "Gestion des utilisateurs",
    pageSubtitle: "Gérez les rôles, l'accès OnSite+ et le statut des comptes de votre organisation.",
    header: {
      myProfile: "Mon profil",
      manageUsers: "Gestion des utilisateurs",
      logout: "Déconnexion"
    },
    table: {
      user: "Utilisateur",
      role: "Fonction",
      roleHelp: "La fonction sert à assigner la personne aux projets (chargé de projet, surintendant, coordonnateur, adjoint).",
      trade: "Métier",
      onsitePlus: "OnSite+",
      viewAllProjects: "Tous les projets",
      status: "Statut",
      actions: "Actions"
    },
    roles: {
      admin: "Administrateur",
      pm: "Chargé de projet",
      assistant: "Assistant",
      supervisor: "Surintendant",
      coordinator: "Coordonnateur",
      accountant: "Comptable",
      worker: "Travailleur"
    },
    status: {
      active: "Actif",
      inactive: "Désactivé"
    },
    actions: {
      deactivate: "Désactiver le compte",
      reactivate: "Réactiver le compte"
    },
    tooltips: {
      cannotEditOwnRole: "Vous ne pouvez pas modifier votre propre rôle",
      cannotDeactivateSelf: "Vous ne pouvez pas désactiver votre propre compte",
      viewAllProjectsAdmin: "Les admins voient déjà tous les projets",
      viewAllProjectsAccountant: "Les comptables voient déjà tous les projets",
      viewAllProjectsSelf: "Vous ne pouvez pas modifier votre propre accès"
    },
    modals: {
      roleChange: {
        title: "Confirmer le changement de rôle",
        message: "Changer {name} de {oldRole} à {newRole} ?"
      },
      onsitePlus: {
        title: "Accès OnSite+",
        enableMessage: "Activer l'accès OnSite+ pour {name} ?",
        disableMessage: "Désactiver l'accès OnSite+ pour {name} ?"
      },
      deactivate: {
        title: "Désactiver le compte",
        message: "Désactiver le compte de {name} ?",
        warning: "Cette personne ne pourra plus se connecter ni voir aucun projet."
      },
      reactivate: {
        title: "Réactiver le compte",
        message: "Réactiver le compte de {name} ?"
      },
      blocked: {
        lastAdminUsersPage: "Impossible : cette personne est le dernier administrateur actif, et ce gabarit n\'ouvre pas la page Utilisateurs. Elle perdrait la gestion des accès sans aucun moyen d\'y revenir.",
        title: "Action bloquée",
        message: "L'organisation doit toujours avoir au moins un administrateur actif. Cette action ne peut pas être effectuée."
      },
      viewAllProjects: {
        title: "Modifier l'accès étendu",
        enableMessage: "Accorder à {name} l'accès en lecture à tous les projets et factures ?",
        disableMessage: "Révoquer l'accès étendu de {name} ?"
      }
    },
    toasts: {
      roleUpdated: "Rôle mis à jour avec succès.",
      onsiteUpdated: "Accès OnSite+ mis à jour.",
      viewAllProjectsUpdated: "Accès étendu mis à jour.",
      deactivated: "Compte désactivé.",
      reactivated: "Compte réactivé.",
      invitedEmail: "Invitation envoyée. L\'utilisateur recevra un courriel pour définir son mot de passe.",
      invitedPassword: "Utilisateur créé. N\'oubliez pas de lui communiquer le mot de passe temporaire directement."
    },
    errors: {
      loadFailed: "Impossible de charger les utilisateurs. Veuillez réessayer.",
      updateFailed: "Échec de la mise à jour. Veuillez réessayer.",
      inviteSeatLimit: "Limite de sièges atteinte. Vous ne pouvez pas ajouter d\'autres utilisateurs à cette organisation.",
      inviteEmailExists: "Cette adresse courriel est déjà associée à un compte.",
      inviteNotAdmin: "Vous devez être un administrateur actif pour inviter des utilisateurs.",
      inviteFailed: "L\'invitation a échoué. Veuillez réessayer.",
      inviteEmailRequired: "L\'adresse courriel est obligatoire.",
      invitePasswordTooShort: "Le mot de passe temporaire doit comporter au moins 12 caractères."
    },
    invite: {
      button: "Inviter un utilisateur",
      title: "Inviter un utilisateur",
      subtitle: "Ajoutez un nouveau membre à votre organisation.",
      emailLabel: "Adresse courriel",
      emailPlaceholder: "nom@entreprise.com",
      fullNameLabel: "Nom complet (facultatif)",
      fullNamePlaceholder: "Jean Tremblay",
      roleLabel: "Rôle",
      tradeLabel: "Métier",
      tradePlaceholder: "Aucun métier",
      productAccessLabel: "Accès aux produits",
      productOnsitePM: "OnsitePM",
      productOnsitePlus: "OnSite+",
      productOnsiteES: "OnsiteES",
      productComingSoon: "bientôt disponible",
      modeLabel: "Méthode d\'activation",
      modeEmail: "Envoyer un courriel d\'invitation",
      modePassword: "Définir un mot de passe temporaire",
      tempPasswordLabel: "Mot de passe temporaire",
      generate: "Générer",
      copy: "Copier",
      copied: "Copié !",
      submit: "Créer l\'utilisateur",
      submitting: "Création en cours...",
      cancel: "Annuler"
    }
  },
  settings: {
    organization: {
      title: "Informations de l\'entreprise",
      addressLabel: "Adresse",
      phoneLabel: "Téléphone",
      saveBtn: "Enregistrer",
      saveSuccess: "Informations mises à jour",
      taglineLabel: "Slogan / Tagline",
      emailLabel: "Courriel",
      websiteLabel: "Site web",
      rbqLabel: "RBQ",
      tpsLabel: "N° TPS",
      tvqLabel: "N° TVQ",
      logoLabel: "Logo de l\'entreprise",
      logoUploadBtn: "Choisir un fichier",
      logoRemoveBtn: "Retirer",
      logoSvgNotSupported: "Les logos SVG ne sont pas supportés (PNG, JPG, WEBP seulement)",
      logoTooLarge: "Logo trop volumineux (max 5 MB)",
      logoUploadSuccess: "Logo mis à jour",
      logoRemoveSuccess: "Logo retiré"
    }
  },
  status: {
    active: "Actif",
    completed: "Terminé",
    pending: "En attente",
    onHold: "En pause",
    archived: "Archivé",
    draft: "Brouillon",
    submitted: "Soumis",
    to_resubmit: "À resoumettre",
    approved: "Approuvé",
    rejected: "Rejeté",
    pendingSignature: "En attente de signature",
    signed: "Signé",
    cancelled: "Annulé"
  },
  login: {
    title: "OnSitePm",
    subtitle: "Connectez-vous à votre compte",
    emailLabel: "Courriel",
    emailPlaceholder: "Entrez votre courriel",
    passwordLabel: "Mot de passe",
    passwordPlaceholder: "Entrez votre mot de passe",
    signingIn: "Connexion en cours...",
    signIn: "Se connecter",
    demoAccount: "Compte de démonstration",
    useDemoCredentials: "Utiliser les identifiants de démo",
    emailField: "Courriel :",
    passwordField: "Mot de passe :",
    needHelp: "Besoin d\'aide ? Contactez le support",
    loadingAuth: "Chargement...",
    signInTitle: "Connectez-vous à votre espace",
    signInSubtitle: "Entrez vos identifiants pour accéder à vos projets",
    signInButton: "Se connecter",
    noAccount: "Vous n\'avez pas de compte ?",
    signUp: "Créer un compte",
    demoAccess: "Accès Démo",
    useDemo: "Utiliser les identifiants démo",
    poweredBy: "OnsitePM",
    contracts: "Contrats",
    subcontractors: "Sous-traitants",
    financials: "Finances",
    heroTagline: "Protégez vos profits avant la fin du projet",
    heroSubtitle: "Intelligence opérationnelle pour les équipes de construction modernes.",
    tagline: "Intelligence opérationnelle pour les équipes de construction modernes",
    accountInactive: "Votre compte a été désactivé.",
    accountInactiveHint: "Veuillez communiquer avec votre administrateur pour réactiver votre accès."
  },
  profile: {
    title: "Mon profil",
    subtitle: "Gérer vos informations personnelles",
    fullNameLabel: "Nom complet",
    fullNamePlaceholder: "Entrez votre nom complet",
    emailLabel: "Courriel",
    emailPlaceholder: "Entrez votre courriel",
    phoneLabel: "Téléphone",
    phonePlaceholder: "Entrez votre numéro de téléphone",
    roleLabel: "Rôle",
    roleReadOnly: "Le rôle est en lecture seule",
    roleNotSet: "Non défini",
    companyLabel: "Entreprise",
    companyPlaceholder: "Entrez le nom de votre entreprise",
    saveChanges: "Enregistrer les modifications",
    saving: "Enregistrement...",
    saveSuccess: "Profil mis à jour avec succès",
    loadingProfile: "Chargement du profil...",
    avatar: {
      editPhoto: "Modifier la photo",
      removePhoto: "Supprimer la photo",
      invalidType: "Format non supporté (JPG, PNG, WebP seulement)",
      tooLarge: "Image trop volumineuse (max 2 Mo)",
      uploadFailed: "Échec du téléversement",
      uploadSuccess: "Photo mise à jour"
    }
  },
  dashboard: {
    title: "Portefeuille de projets",
    subtitle: "Tableau de bord global de tous les projets",
    kpi: {
      totalProjects: "Total des projets",
      totalContractValue: "Valeur totale des contrats",
      totalSubRevised: "Total sous-traitants révisé",
      totalLiveProfit: "Profit en temps réel",
      averageMargin: "Marge moyenne %"
    },
    charts: {
      revenueByProject: "Revenus par projet",
      statusBreakdown: "Répartition par statut",
      profitTrend: "Tendance des profits"
    },
    table: {
      projectNumber: "Projet #",
      projectName: "Nom du projet",
      client: "Client",
      city: "Ville",
      created: "Créé",
      submission: "Soumission",
      actions: "Actions"
    },
    filters: {
      allStatuses: "Tous les statuts",
      allTime: "Toute la période",
      today: "Aujourd\'hui",
      thisWeek: "Cette semaine",
      thisMonth: "Ce mois",
      thisQuarter: "Ce trimestre",
      thisYear: "Cette année",
      marginRange: "Plage de marge : {min}% - {max}%",
      statusLabel: "Statut",
      dateRangeLabel: "Période"
    },
    empty: "Aucun projet trouvé",
    bulk: {
      selected: "{count} projets sélectionnés",
      selectedOne: "1 projet sélectionné",
      export: "Exporter",
      archive: "Archiver",
      updateStatus: "Mettre à jour le statut"
    }
  },
  projectList: {
    title: "Projets",
    subtitle: "Gérer et suivre tous les projets actifs",
    searchPlaceholder: "Rechercher par nom...",
    newProject: "Nouveau projet",
    noProjectsAssigned: {
      title: "Aucun projet ne vous est assigné",
      message: "Contactez votre administrateur pour être assigné à un projet."
    },
    table: {
      name: "Nom du projet",
      contract: "Valeur du contrat",
      contractValueRevised: "Valeur du contrat (révisée)",
      expenses: "Dépenses",
      profit: "Profit",
      margin: "Marge",
      status: "Statut",
      actions: "Actions"
    },
    filter: {
      title: "Filtrer les projets",
      clear: "Effacer les filtres",
      searchName: "Rechercher par nom...",
      searchNumber: "Rechercher par numéro...",
      searchUniversal: "Rechercher par nom, numéro ou client...",
      allClients: "Tous les clients",
      projectsCount: "Projets",
      yearFilter: {
        all: "Toutes"
      },
      empty: "Aucun projet trouvé",
      projectNumber: "Projet #",
      edit: "Modifier",
      archive: "Archiver",
      delete: "Supprimer"
    }
  },
  newProjectModal: {
    titleCreate: "Nouveau projet",
    titleEdit: "Modifier le projet",
    subtitleCreate: "Créer et configurer un nouveau projet",
    subtitleEdit: "Mettre à jour les détails et la configuration du projet",
    sectionIdentity: "Identité du projet",
    sectionClientFinancials: "Client et finances",
    sectionClassification: "Classification",
    sectionSchedule: "Calendrier",
    sectionLocation: "Localisation",
    sectionNotes: "Notes",
    projectName: "Nom du projet",
    projectNamePlaceholder: "Entrez le nom du projet",
    projectNameRequired: "Le nom du projet est requis",
    projectNumber: "Numéro de projet",
    projectNumberPlaceholder: "Généré automatiquement si vide",
    projectNumberHelper: "Laisser vide pour numérotation automatique (ex: P26-010)",
    projectNumberDuplicate: "Ce numéro de projet existe déjà dans votre organisation",
    clientProjectNumber: "Numéro de projet du client",
    clientProjectNumberPlaceholder: "Optionnel — ex: référence de l\'architecte",
    clientProjectNumberHelper: "Référence externe pour le client ou l\'architecte (optionnel)",
    clientNumberLabel: "N° client",
    contractValue: "Valeur du contrat (calculée automatiquement)",
    contractValuePlaceholder: "Entrez la valeur du contrat",
    contractValueAuto: "Calculée à partir des coûts du projet",
    contractValueHelper: "Calculée automatiquement à partir des codes de coût",
    client: "Client",
    clientPlaceholder: "Entrez le nom du client",
    constructionType: "Type de construction",
    constructionTypePlaceholder: "Sélectionner le type de construction",
    workNature: "Nature des travaux",
    workNaturePlaceholder: "Sélectionner la nature des travaux",
    architect: "Architecte",
    architectPlaceholder: "Entrez le nom de l\'architecte",
    submissionDate: "Date de soumission",
    startDate: "Date de début",
    endDate: "Date de fin",
    timeframe: "Durée du projet",
    timeframeHelper: "Calculée automatiquement à partir des dates de début et de fin",
    address: "Adresse",
    addressPlaceholder: "Entrez l\'adresse",
    city: "Ville",
    cityPlaceholder: "Entrez la ville",
    state: "Province",
    statePlaceholder: "Entrez la province",
    zipCode: "Code postal",
    zipCodePlaceholder: "Entrez le code postal",
    description: "Description",
    descriptionPlaceholder: "Entrez la description du projet",
    statusLabel: "Statut",
    cancel: "Annuler",
    createProject: "Créer le projet",
    saveChanges: "Enregistrer les modifications",
    creating: "Création...",
    saving: "Enregistrement..."
  },
  projectStatus: {
    active: "En cours",
    "on-hold": "En attente",
    pending: "En traitement",
    completed: "Terminé",
    cancelled: "Annulé",
    archived: "Archivé",
    deleted: "Supprimé"
  },
  deleteModal: {
    title: "Supprimer le projet",
    message: "Ceci supprimera le projet de votre compte. Cette action peut être annulée ultérieurement.",
    projectLabel: "Projet :",
    cancel: "Annuler",
    delete: "Supprimer"
  },
  projectDirectory: {
    title: "Répertoire du projet",
    subtitle: "Équipe et contacts attribués à ce projet",
    sidebarLabel: "Répertoire",
    tabs: {
      subcontractors: "Sous-traitants",
      clients: "Clients",
      professionals: "Professionnels"
    },
    searchPlaceholder: "Rechercher par entreprise, contact, courriel...",
    filterAllTrades: "Tous les corps de métier",
    filterAllProfessions: "Toutes les professions",
    inactive: "Inactif",
    columns: {
      companyName: "Nom de l\'entreprise",
      trade: "Corps de métier",
      profession: "Profession",
      role: "Rôle (ce projet)",
      contactPerson: "Personne-ressource",
      phone: "Téléphone",
      email: "Courriel",
      address: "Adresse",
      rating: "Évaluation",
      actions: "Actions"
    },
    buttons: {
      add: "Ajouter",
      edit: "Modifier",
      detach: "Retirer",
      cancel: "Annuler",
      save: "Enregistrer"
    },
    modals: {
      attachSubcontractor: { title: "Ajouter un sous-traitant au projet" },
      attachClient: { title: "Ajouter un client au projet" },
      attachProfessional: { title: "Ajouter un professionnel au projet" },
      editTitle: "Modifier l'entrée du projet",
      attachField: {
        label: "Sélectionner dans le répertoire de l\'entreprise",
        placeholder: "Rechercher et sélectionner..."
      },
      role: {
        label: "Rôle sur ce projet",
        placeholderSub: "ex. Contremaître, Charpentier principal",
        placeholderClient: "ex. Contact principal, Commanditaire du projet",
        placeholderProfessional: "ex. Architecte du projet, Ingénieur mécanique de référence"
      },
      notes: {
        label: "Notes (optionnel)",
        placeholder: "Notes internes sur ce membre de l\'équipe pour ce projet..."
      },
      activeLabel: "Actif sur ce projet",
      detachConfirm: {
        title: "Retirer du projet",
        message: "Retirer {name} de ce projet ? Ils resteront dans le répertoire de l'entreprise."
      },
      noAvailable: "Toutes les entrées sont déjà attachées à ce projet",
      errorSelectEntry: "Veuillez sélectionner une entrée du répertoire",
      errorRoleRequired: "Le rôle est obligatoire",
      errorDuplicate: "Cette entrée est déjà attachée à ce projet",
      errorGeneric: "Une erreur s\'est produite. Veuillez réessayer."
    },
    toast: {
      attached: "Entrée attachée au projet",
      updated: "Entrée mise à jour",
      detached: "Entrée retirée du projet"
    },
    empty: {
      subcontractors: "Aucun sous-traitant attribué à ce projet",
      clients: "Aucun client attribué à ce projet",
      professionals: "Aucun professionnel attribué à ce projet"
    },
    permissions: {
      readOnly: "Lecture seule — seul le GP ou un administrateur peut modifier ce répertoire"
    },
    errors: {
      noProjectId: "Projet introuvable"
    }
  },
  directory: {
    title: "Répertoire",
    subtitle: "Gérer les contacts de l'entreprise (sous-traitants, clients, professionnels)",
    addSubcontractor: "Ajouter un sous-traitant",
    addClient: "Ajouter un client",
    addProfessional: "Ajouter un professionnel",
    types: {
      subcontractor: "Sous-traitants",
      client: "Clients",
      professional: "Professionnels"
    },
    contactsCount: "{count} Contacts",
    filter: {
      title: "Filtrer le répertoire",
      contacts: "Contacts",
      clearFilters: "Effacer les filtres",
      searchPlaceholder: "Rechercher par entreprise, contact, courriel...",
      allTrades: "Tous les corps de métier",
      allProfessions: "Toutes les professions"
    },
    table: {
      companyName: "Nom de l\'entreprise",
      trade: "Corps de métier",
      contactPerson: "Personne-ressource",
      phone: "Téléphone",
      email: "Courriel",
      actions: "Actions",
      profession: "Profession",
      rating: "Évaluation",
      address: "Adresse",
      notes: "Notes",
      compliance: "Conformité"
    },
    empty: "Aucun contact trouvé",
    modal: {
      titleAdd: "Ajouter un nouveau sous-traitant",
      titleEdit: "Modifier le sous-traitant",
      titleAddClient: "Ajouter un client",
      titleEditClient: "Modifier le client",
      titleAddProfessional: "Ajouter un professionnel",
      titleEditProfessional: "Modifier le professionnel",
      companyName: "Nom de l\'entreprise",
      companyNamePlaceholder: "Entrez le nom de l\'entreprise",
      trade: "Corps de métier",
      tradeSelectPlaceholder: "Sélectionner le corps de métier",
      contactPerson: "Personne-ressource",
      contactPersonPlaceholder: "Entrez le nom de la personne-ressource",
      phone: "Téléphone",
      phonePlaceholder: "(555) 123-4567",
      email: "Courriel",
      emailPlaceholder: "contact@entreprise.com",
      profession: "Profession",
      professionPlaceholder: "Sélectionner une profession",
      address: "Adresse",
      addressPlaceholder: "Saisir l\'adresse",
      notes: "Notes",
      notesPlaceholder: "Notes internes (visibles à votre équipe seulement)",
      rating: "Évaluation",
      cancel: "Annuler",
      add: "Ajouter",
      update: "Mettre à jour",
      close: "Fermer",
      edit: "Modifier",
      save: "Enregistrer",
      status: "Statut",
      statusActive: "Actif",
      statusInactive: "Inactif",
      sectionSpecialties: "Spécialités",
      specialtyPrimary: "Spécialité principale",
      specialtyOthers: "Autres spécialités",
      specialtyUndefined: "À définir",
      specialtiesLoading: "Chargement des spécialités…",
      specialtiesLoadError: "Les spécialités n'ont pas pu être chargées.",
      specialtiesEditHint: "Les spécialités se modifient dans OnSiteBid.",
      tradeLabel: "Métier",
      sectionEstimation: "Contact estimation",
      estimationHint: "Reçoit les demandes de soumission. Vide = personne-ressource.",
      sectionCompany: "Entreprise",
      cityOrAddress: "Ville ou adresse",
      taxId: "NEQ",
      sectionDocuments: "Documents",
      invalidEmail: "Adresse courriel invalide.",
      saving: "Enregistrement...",
      requiredFields: "Veuillez remplir tous les champs obligatoires",
      sectionGeneral: "Informations générales",
      sectionContact: "Contact principal",
      sectionCompliance: "Conformité",
      sectionContacts: "Contacts additionnels",
      sectionRating: "Évaluation",
      rbqNumber: "Numéro RBQ",
      rbqExpiry: "Expiration RBQ",
      insuranceExpiry: "Expiration de l\'assurance",
      insuranceDoc: "Document d\'assurance",
      rbqDoc: "Document RBQ",
      addContact: "+ Ajouter un contact",
      contactRole: "Rôle",
      contactName: "Nom",
      contactEmail: "Courriel",
      contactPhone: "Téléphone",
      chooseFile: "Choisir un fichier",
      noAdditionalContacts: "Aucun contact additionnel",
      viewFile: "Voir",
      removeFile: "Retirer",
      svgNotSupported: "SVG non supporté (PDF, JPG, PNG seulement)",
      fileTooLarge: "Fichier trop volumineux (max 20 Mo)"
    },
    deleteModal: {
      title: "Supprimer le contact",
      message: "Êtes-vous sûr de vouloir supprimer ce contact ? Cette action est irréversible.",
      cancel: "Annuler",
      delete: "Supprimer"
    },
    dropdown: {
      edit: "Modifier",
      delete: "Supprimer"
    },
    expiry: {
      expired: "Expiré",
      expiresIn: "Expire dans {days}j",
      upToDate: "À jour"
    }
  },
  contactRoles: {
    accounting: "Comptabilité",
    projectManagement: "Gestion projet",
    projectLead: "Chargé projet",
    coordinator: "Coordonnateur",
    other: "Autre"
  },
  budget: {
    errors: {
      divisionNeedsDigit: "Le numéro de division doit contenir au moins un chiffre (ex. « 2 » ou « 02 »)."
    },
    title: "Aperçu financier",
    subtitle: "Suivi des coûts, de la performance et de la rentabilité du projet en temps réel",
    kpi: {
      initialBudget: "Budget initial",
      extraCredit: "Extra/Crédit",
      totalActualCost: "Coût réel total",
      liveProfit: "Profit en temps réel",
      profitMargin: "Marge bénéficiaire"
    },
    tabs: {
      construction: "Coût de construction",
      general: "Coût général",
      admin: "Admin & Profit",
      extras: "Extras & Crédits"
    },
    addCostCode: "Ajouter un code de coût",
    addFirstCostCode: "Ajouter le premier code de coût",
    table: {
      costCode: "Code de coût",
      description: "Description",
      budget: "Budget",
      actual: "Réel",
      signedContract: "Contrat signé",
      expenses: "Dépenses",
      commitment: "Engagement",
      initialValue: "Valeur initiale",
      forecast: "Prévision",
      pl: "P/L",
      plPercent: "P/L %",
      actions: "Actions",
      totalExpenses: "total des dépenses",
      type: "Type",
      coNumber: "N° CO"
    },
    filters: {
      all: "Tous les codes de coût",
      overBudget: "Dépassement de budget uniquement",
      underBudget: "Sous le budget uniquement",
      zeroVariance: "Variance nulle",
      highVariance: "Variance élevée (>10%)"
    },
    empty: {
      all: "Aucun code de coût dans cette catégorie",
      filtered: "Aucun code de coût ne correspond au filtre sélectionné",
      emptyTitle: "Aucun code de coût pour l\'instant",
      emptyDescription: 'Cliquez sur « Ajouter une division » pour commencer'
    },
    clickToEdit: "Cliquer pour modifier",
    tooltips: {
      deleteCostCode: "Supprimer le code de coût",
      addCostCodeToDivision: "Ajouter un code de coût à cette division",
      divisionActions: "Actions de la division",
      clearFilter: "Effacer le filtre",
      collapse: "Réduire",
      expand: "Développer",
      collapseAll: "Tout réduire",
      expandAll: "Tout développer",
      commitmentTotal: "Total"
    },
    extras: {
      loadingLines: "Chargement des lignes...",
      noLines: "Aucune ligne trouvée"
    },
    division: {
      label: "Division",
      subtotal: "Sous-total",
      items: "éléments",
      ungrouped: "Sans division",
      editDivision: "Modifier la division",
      deleteDivision: "Supprimer la division",
      cannotDeleteDivision: "Impossible de supprimer la division car elle contient des codes de coût.",
      cannotDeleteWithCount: "Cette division contient {count} code(s) de coût. Supprimez-les d'abord.",
      deleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer cette division ?",
      deleteIrreversible: "Cette action est irréversible.",
      deleting: "Suppression...",
      errorUpdating: "Erreur lors de la modification de la division"
    },
    addDivision: {
      title: "Ajouter une division",
      divisionNumber: "Numéro de division",
      divisionNumberPlaceholder: "Ex: 02",
      divisionTitle: "Titre de la division",
      divisionTitlePlaceholder: "Ex: Conditions existantes",
      submit: "Ajouter la division",
      searchPlaceholder: "Rechercher une division...",
      addToProject: "Ajouter au projet",
      alreadyAdded: "(ajoutée)",
      divisionLabel: "Division {number}",
      noDivisionsFound: "Aucune division trouvée",
      adding: "Ajout...",
      toastAlreadyAdded: "Division déjà ajoutée",
      errorNoDigit: "Le numéro de division doit contenir au moins un chiffre",
      errorAlreadyExists: "La division {code} existe déjà",
      errorCreating: "Erreur lors de la création de la division",
      errorAddFailed: "Échec de l'ajout de la division"
    },
    addCostCodeModal: {
      title: "Ajouter un code de coût",
      division: "Division",
      costCode: "Code de coût",
      description: "Description",
      descriptionPlaceholder: "ex. Démolition sélective",
      submit: "Ajouter le code de coût"
    },
    deleteCostCode: {
      confirmTitle: "Supprimer le code de coût",
      confirmMessage: "Êtes-vous sûr de vouloir supprimer ce code de coût ?",
      blockedTitle: "Impossible de supprimer le code de coût",
      blockedMessage: "Ce code de coût ne peut pas être supprimé car il est lié à des enregistrements financiers.",
      linkedContracts: "Contrats liés",
      invoiceLabel: "Facture",
      linkedInvoices: "Factures liées",
      linkedExpenses: "Dépenses liées",
      warningTitle: "Avertissement",
      warningMessage: "Ce code de coût a une valeur Réelle supérieure à 0 $. Sa suppression peut entraîner des incohérences.",
      deleteAnyway: "Supprimer quand même"
    },
    createContract: {
      button: "Créer un contrat",
      cancel: "Annuler",
      countSelected: "{count} sélectionné(s)",
      success: "{count} contrat(s) placeholder créé(s)",
      error: "Échec de la création des contrats. Veuillez réessayer."
    }
  },
  contracts: {
    title: "Gestion des contrats",
    subtitle: "Gérer les contrats de sous-traitance",
    addContract: "Ajouter un contrat",
    createSubcontractAgreement: "Créer une entente de sous-traitance",
    documentType: "Type de document",
    pricingModel: "Modèle de tarification",
    documentTypeOptions: {
      contract: "Contrat",
      purchaseOrder: "Bon de commande"
    },
    pricingModelOptions: {
      fixed: "Forfait",
      laborMaterial: "Temps et matériel",
      materialSupply: "Fournitures de matériaux"
    },
    costCode: "Code de coût",
    subcontractor: "Sous-traitant",
    contractValue: "Valeur du contrat",
    notes: "Notes",
    cancel: "Annuler",
    addContractButton: "Ajouter le contrat",
    kpi: {
      totalContracts: "Total des contrats",
      totalValue: "Valeur totale",
      pendingSignature: "En attente de signature",
      signed: "Signé"
    },
    filters: {
      searchPlaceholder: "Rechercher un contrat...",
      subcontractorPlaceholder: "Sous-traitant",
      tradePlaceholder: "Corps de métier",
      allStatus: "Tous les statuts",
      pendingSignature: "En attente de signature",
      signed: "Signé",
      clear: "Effacer",
      contracts: "contrats"
    },
    table: {
      title: "Liste des contrats",
      addContract: "Ajouter un contrat",
      noContracts: "Aucun contrat trouvé. Cliquez sur \"Ajouter un contrat\" pour en créer un.",
      coAv: "AV",
      revisedContract: "Contrat révisé",
      status: "Statut",
      actions: "Actions"
    },
    empty: {
      emptyTitle: "Aucun contrat pour l\'instant",
      emptyDescription: 'Cliquez sur « Ajouter un contrat » pour commencer'
    },
    noteModal: {
      title: "Note de contrat",
      placeholder: "Ajouter une note pour ce contrat...",
      addNote: "Ajouter une note",
      editNote: "Modifier la note"
    },
    actions: {
      edit: "Modifier",
      viewDocuments: "Voir documents",
      delete: "Supprimer"
    },
    addModal: {
      title: "Ajouter un contrat",
      editTitle: "Modifier le contrat",
      editSubtitle: "Mettre à jour les détails du contrat ci-dessous",
      costCodeLabel: "Code de coût *",
      costCodePlaceholder: "Sélectionner un code de coût",
      noCostCodes: "Aucun code de coût de construction disponible pour ce projet.",
      subcontractorLabel: "Sous-traitant *",
      subcontractorPlaceholder: "Sélectionner un sous-traitant",
      noSubcontractors: "Aucun sous-traitant disponible. Veuillez d\'abord ajouter des sous-traitants.",
      contractValueLabel: "Valeur du contrat *",
      contractValuePlaceholder: "0.00",
      notesLabel: "Notes (facultatif)",
      notesPlaceholder: "Ajouter des notes supplémentaires...",
      cancel: "Annuler",
      addContract: "Ajouter le contrat",
      saveChanges: "Enregistrer les modifications",
      adding: "Ajout en cours...",
      saving: "Enregistrement...",
      validationCostCode: "Veuillez sélectionner un code de coût",
      validationSubcontractor: "Veuillez sélectionner un sous-traitant",
      validationContractValue: "La valeur du contrat doit être supérieure à 0",
      failedCreate: "Échec de la création du contrat. Veuillez réessayer.",
      failedUpdate: "Échec de la mise à jour du contrat. Veuillez réessayer."
    },
    statusLocked: {
      tooltip: "Assignez un sous-traitant pour changer le statut"
    },
    statusOptions: {
      toAssign: "À assigner",
      draft: "Brouillon",
      pendingSignature: "En attente de signature",
      sent: "Envoyé",
      signed: "Signé",
      completed: "Completed",
      cancelled: "Annulé"
    }
  },
  extras: {
    createCOModal: {
      title: "Créer un avenant de sous-traitance",
      submit: "Créer l\'avenant"
    },
    title: "Directives & Extras",
    subtitle: "Gérer les ordres de travaux supplémentaires et les crédits",
    kpi: {
      draft: "Brouillon",
      submitted: "Soumis",
      approved: "Approuvé",
      extra: "Extra",
      credit: "Crédit",
      total: "Total",
      rejected: "Rejeté"
    },
    toolbar: {
      items: "élément",
      itemsPlural: "éléments",
      approved: "approuvé",
      addExtraCredit: "Ajouter Extra/Crédit",
      allStatuses: "Tous les statuts",
      searchPlaceholder: "Rechercher extras et crédits..."
    },
    table: {
      number: "#",
      type: "Type",
      coNumber: "N° CO",
      co: "# directive",
      title: "Titre",
      receivedDate: "Date de réception",
      amount: "Montant",
      costAccepted: "Coût accepté",
      status: "Statut",
      created: "Créé",
      actions: "Actions",
      description: "Description",
      submitted: "Soumis",
      accepted: "Accepté",
      selectAll: "Tout sélectionner",
      changeOrder: "ODC"
    },
    notes: {
      title: "Notes internes",
      none: "Aucune note",
      empty: "Aucune note pour l\'instant.",
      placeholder: "Ajouter une note… (Ctrl+Entrée pour enregistrer)",
      add: "Ajouter",
      save: "Enregistrer",
      edit: "Modifier",
      delete: "Supprimer",
      deleteConfirm: "Supprimer cette note ?",
      edited: "modifiée",
      visibility: "Visible par l\'équipe du projet seulement · jamais dans le PDF",
      loadError: "Impossible de charger les notes.",
      saveError: "Impossible d\'enregistrer la note.",
      tooLong: "La note dépasse {max} caractères.",
      notOwn: "Vous ne pouvez modifier que vos propres notes."
    },
    co: {
      menuLabel: "Ordre de changement (ODC) du client",
      pending: "En attente",
      received: "Reçu",
      receivedOn: "ODC reçu le {date}",
      markReceived: "ODC reçu…",
      resetPending: "Remettre en attente",
      resetTitle: "Remettre l'ODC en attente",
      resetMessage: "L'ordre de changement de « {title} » repassera « En attente ». Le document reste dans les pièces.",
      docRequired: "téléversez l'ODC : il passe à « Reçu » après le téléversement",
      receivedToast: "ODC reçu — document ajouté aux pièces",
      resetToast: "ODC remis en attente",
      error: "Impossible d'enregistrer l'ordre de changement",
      filterPending: "ODC : en attente",
      filterReceived: "ODC : reçu",
      notRequired: "Non requis",
      internalDefault: "Interne"
    },
    types: {
      extra: "Extra",
      credit: "Crédit"
    },
    addExtra: "Ajouter extra",
    addCredit: "Ajouter crédit",
    editExtra: "Modifier extra",
    editCredit: "Modifier crédit",
    viewExtra: "Détail de l\'extra",
    viewCredit: "Détail du crédit",
    viewLockedApproved: "Un extra approuvé ne peut plus être modifié",
    empty: {
      noExtras: "Aucun extra ou crédit pour l\'instant",
      clickToAdd: "Cliquez sur \"Ajouter Extra\" pour commencer"
    },
    deleteDialog: {
      title: "Supprimer l\'entrée",
      message: "Êtes-vous sûr de vouloir supprimer cet extra / crédit ? Cette action est irréversible.",
      cancel: "Annuler",
      delete: "Supprimer"
    },
    locked: "Verrouillé — un avenant signé existe",
    rowActions: {
      actions: "Actions",
      documents: "Documents",
      noDocuments: "Aucun document",
      moreDocuments: "+{count} de plus",
      revertStatus: "Rétablir le statut",
      changeStatus: "Changer le statut"
    },
    bulk: {
      selected: "{count} sélectionné(s)",
      approve: "Approuver",
      approveTooltip: "Approuver la sélection",
      submit: "Soumettre",
      submitTooltip: "Marquer comme soumis",
      status: "Statut",
      draft: "Brouillon",
      reject: "Rejeter",
      export: "Exporter",
      exportCsv: "Exporter CSV",
      exportPdf: "Exporter PDF",
      clear: "Effacer",
      clearTooltip: "Effacer la sélection"
    },
    export: {
      title: "Extras et crédits",
      selectedLabel: "Sélection ({count})",
      exportedOn: "Exporté le {date}",
      totalItems: "Total ({count} éléments)",
      csvTooltip: "Exporter tout en CSV",
      pdfTooltip: "Exporter tout en PDF",
      columns: {
        type: "Type",
        coNumber: "N° CO",
        description: "Description",
        submitted: "Soumis",
        accepted: "Accepté",
        status: "Statut"
      }
    },
    downloadPdf: "Télécharger PDF",
    approve: {
      title: "Créer les avenants",
      subtitle: "Choisissez les lignes à transformer en avenants pour chaque sous-traitant.",
      notes: "Notes",
      description: "Description",
      descriptionRequired: "Décrivez ce que l'avenant doit contenir",
      confirm: "Créer les avenants",
      cancel: "Annuler",
      total: "Total"
    },
    addModal: {
      title: "Ajouter Extra / Crédit",
      typeLabel: "Type",
      typeExtra: "+ Extra",
      credit: "− Crédit",
      titleLabel: "Titre",
      titlePlaceholder: "ex. Travaux électriques supplémentaires",
      titleRequired: "Le titre est requis",
      descriptionLabel: "Description",
      descriptionPlaceholder: "Description facultative...",
      workDescriptionLabel: "Description des travaux",
      optional: "(facultatif)",
      coNumberFromDirective: "Numéro de la directive liée (non modifiable)",
      amountLabel: "Montant",
      amountPlaceholder: "0.00",
      amountRequired: "Le montant doit être supérieur à 0",
      divisionLabel: "Division",
      divisionPlaceholder: "Sélectionner une division...",
      coNumberLabel: "Numéro de directive",
      coNumberPlaceholder: "ex. CO-001",
      receivedDateLabel: "Date de réception",
      costSubmittedLabel: "Coût soumis",
      costAcceptedLabel: "Coût accepté",
      subtitle: "Créer un travail supplémentaire ou un crédit",
      subtitleCredit: "Créer un crédit sur ce projet",
      linesRequired: "Ajoutez au moins une ligne",
      loadingFiles: "Chargement des fichiers...",
      filesAfterSave: "Les fichiers seront téléversés après l\'enregistrement.",
      extraLines: "Lignes (sous-traitants)",
      creditLines: "Lignes de crédit",
      linesTotalLabel: "Total des lignes (hors taxes)",
      addLine: "Ajouter une ligne",
      cancel: "Annuler",
      add: "Ajouter",
      saving: "Enregistrement..."
    },
    editModal: {
      title: "Modifier Extra / Crédit",
      typeLabel: "Type",
      extraWork: "+ Travaux supplémentaires",
      credit: "− Crédit",
      titleLabel: "Titre",
      titlePlaceholder: "ex. Travaux électriques supplémentaires",
      titleRequired: "Le titre est requis",
      descriptionLabel: "Description",
      descriptionPlaceholder: "Description facultative...",
      amountLabel: "Montant",
      amountPlaceholder: "0.00",
      amountRequired: "Le montant doit être supérieur à 0",
      statusLabel: "Statut",
      cancel: "Annuler",
      saveChanges: "Enregistrer les modifications",
      saving: "Enregistrement..."
    },
    category: {
      label: "Catégorie",
      required: "Veuillez sélectionner une catégorie",
      contractual: "Contractuel",
      backcharge: "Rétrofacturation",
      internal_error: "Erreur interne",
      absorbed_tm: "T&M absorbé",
      dispute: "Litige"
    },
    divisions: {
      architecture: "Architecture",
      electrical: "Électricité",
      plumbing: "Plomberie",
      hvac: "CVAC",
      mechanical: "Mécanique",
      structural: "Structure",
      civil: "Génie civil"
    },
    tabs: {
      directives: "Directives",
      extras: "Extras & Crédits"
    },
    directives: {
      toolbar: {
        searchPlaceholder: "Rechercher une directive...",
        newDirective: "Nouvelle directive"
      },
      table: {
        number: "N°",
        nomenclature: "Nomenclature",
        division: "Division",
        title: "Titre & description",
        receivedOn: "Reçue le",
        status: "Statut",
        documents: "Pièces",
        documentsCountUnknown: "Nombre de pièces indisponible — cliquez pour ouvrir",
        noDocuments: "Aucun document joint",
        overdue: "À évaluer depuis {days} j",
        overdueShort: "{days} j",
        actions: "Actions"
      },
      outcome: {
        pending: "À évaluer",
        extra: "Extra créé",
        credit: "Crédit créé",
        no_impact: "Sans impact"
      },
      actions: {
        createExtra: "Créer un extra",
        createCredit: "Créer un crédit",
        menu: "Actions",
        edit: "Modifier",
        history: "Historique",
        delete: "Supprimer"
      },
      empty: {
        none: "Aucune directive pour l\'instant",
        createFirst: "Cliquez sur « Nouvelle directive » pour commencer"
      },
      documentsSubtitle: "Directive n° {number}",
      files: {
        hint: "PDF seulement · Max 20 Mo",
        open: "Ouvrir",
        download: "Télécharger",
        rename: "Renommer",
        renameSave: "Enregistrer le nom",
        renameCancel: "Annuler",
        standardName: "Nom standard",
        errorPdfOnly: "{name} : PDF seulement",
        errorTooLarge: "{name} : dépasse 20 Mo",
        errorUpload: "{name} : échec du téléversement",
        errorLoad: "Les pièces n'ont pas pu être chargées.",
        errorEmptyName: "Le nom ne peut pas être vide.",
        errorRename: "Le nom n'a pas pu être enregistré.",
        errorDelete: "La pièce n'a pas pu être supprimée."
      },
      create: {
        title: "Nouvelle directive",
        subtitle: "Consigner une directive reçue du professionnel",
        divisionLabel: "Division",
        divisionPlaceholder: "Sélectionner une division...",
        divisionRequired: "La division est requise",
        professionalLabel: "Professionnel",
        professionalPlaceholder: "Sélectionner un professionnel...",
        professionalRequired: "Le professionnel est requis",
        noProfessionals: "Aucun professionnel actif sur ce projet",
        titleLabel: "Titre",
        titlePlaceholder: "ex. Reprise du plafond du hall",
        titleRequired: "Le titre est requis",
        nomenclatureLabel: "Nomenclature",
        nomenclaturePlaceholder: "ex. DDC-A-01",
        nomenclatureRequired: "La nomenclature est requise",
        nomenclatureHint: "Format DDC-discipline-numéro, ex. DDC-A-01.",
        nomenclatureSuggest: "Format suggéré : DDC-A-01 (vous pouvez conserver votre saisie).",
        nomenclatureTaken: "Cette nomenclature existe déjà dans ce projet.",
        dateLabel: "Date de la directive",
        dateHint: "La date inscrite sur le document reçu.",
        dateRequired: "La date de la directive est requise",
        rfiLabel: "Vient d\'une QRT ?",
        rfiPlaceholder: "Aucune",
        descriptionLabel: "Description",
        descriptionPlaceholder: "Ce que la directive demande...",
        descriptionRequired: "La description est requise",
        documentsLabel: "Pièces jointes",
        documentsHint: "PDF seulement · Max 20 Mo",
        submit: "Créer la directive",
        saving: "Enregistrement...",
        numberCollision: "Le numéro attribué est déjà pris. Réessayez.",
        error: "La directive n\'a pas pu être créée."
      },
      outcomeError: "L\'issue de la directive n\'a pas pu être enregistrée.",
      extraCreatedToast: "Extra créé — voir l\'onglet Extras & Crédits",
      creditCreatedToast: "Crédit créé — voir l\'onglet Extras & Crédits",
      noImpactToast: "Directive classée sans impact",
      rollbackNotice: "L\'extra a été retiré : la directive n\'a pas pu être mise à jour.",
      orphanNotice: "Extra {number} créé, mais la directive n\'a pas pu être mise à jour. Rattachez-les manuellement.",
      none: "Sans directive",
      edit: {
        mode: "Modification",
        submit: "Enregistrer",
        error: "La directive n'a pas pu être enregistrée.",
        discardTitle: "Abandonner les modifications ?",
        discardMessage: "Les changements non enregistrés seront perdus.",
        discardConfirm: "Abandonner",
        keepEditing: "Continuer la modification"
      },
      outcomeChange: {
        title: "Changer l'issue",
        confirm: "Changer l'issue",
        toLabel: "La directive passera à « {label} ».",
        detach: "L'extra {number} sera détaché de cette directive, mais conservé.",
        linkedExtra: "lié",
        create: "Un {type} brouillon sera créé et relié à cette directive.",
        typeExtra: "extra",
        typeCredit: "crédit"
      },
      delete: {
        title: "Supprimer la directive",
        message: "La directive {name} et ses pièces jointes seront supprimées définitivement.",
        confirm: "Supprimer",
        linkedExtra: "Détachez d'abord l'extra lié : changez l'issue à « À évaluer » ou « Aucun impact ».",
        error: "La directive n'a pas pu être supprimée."
      },
      history: {
        title: "Historique",
        empty: "Aucun changement enregistré.",
        error: "L'historique n'a pas pu être chargé.",
        created: "création",
        system: "Système",
        unknownRef: "(introuvable)",
        note: "Les suppressions ne sont pas journalisées.",
        fields: {
          outcome: "Issue",
          nomenclature: "Nomenclature",
          title: "Titre",
          division: "Division",
          date_directive: "Reçue le",
          professional_id: "Professionnel",
          rfi_id: "QRT d'origine",
          extra_id: "Extra / crédit lié"
        }
      },
      detail: {
        eyebrow: "Directive",
        open: "Ouvrir la fiche",
        enteredBy: "Saisie par",
        enteredOn: "Saisie le",
        openRfis: "Ouvrir les QRT",
        extra: "Extra / crédit lié",
        amountSubmitted: "Montant soumis",
        amountAccepted: "Montant accepté",
        viewInExtras: "Voir dans Extras & Crédits",
        fullHistory: "Tout l'historique",
        noneF: "Aucune",
        noneM: "Aucun",
        close: "Fermer"
      },
      issue: {
        menuLabel: "Changer l'issue de la directive",
        backToPending: "Revenir à « À évaluer »",
        backHint: "Pour choisir une autre issue, revenir d'abord à « À évaluer ».",
        revertDraftMessage: "L'extra brouillon {number} sera supprimé et la directive repassera à « À évaluer ».",
        revertSubmittedTitle: "Extra déjà soumis",
        revertSubmittedMessage: "Un extra a déjà été soumis pour cette directive : {details}. Procéder supprimera cet extra définitivement.",
        revertDeleteConfirm: "Supprimer l'extra et revenir",
        revertBlockedTitle: "Impossible de revenir à « À évaluer »",
        revertBlockedApproved: "Cet extra est approuvé ({details}). Annulez-le d'abord dans Extras & Crédits avant de changer l'issue de la directive.",
        revertBlockedRefs: "L'extra {number} ne peut pas être supprimé : {reasons}. Retirez d'abord ces liens avant de changer l'issue de la directive.",
        reason: {
          invoices: "lié à {count} facture(s) de sous-traitant",
          paymentRequests: "inclus dans {count} ligne(s) de demande de paiement",
          expenses: "lié à {count} dépense(s)",
          changeOrders: "lié à {count} avenant(s) envoyé(s) ou signé(s)"
        },
        close: "Fermer",
        revertedToast: "Extra {number} supprimé, directive repassée à « À évaluer »",
        checkError: "Impossible de vérifier l'extra lié. Réessayez.",
        revertError: "La directive n'a pas pu être remise à « À évaluer ». Rien n'a été supprimé.",
        deleteFailed: "L'extra n'a pas pu être supprimé. La directive a été remise dans son état précédent.",
        deleteFailedNoRestore: "L'extra n'a pas pu être supprimé et la directive n'a pas pu être restaurée. Vérifiez dans Extras & Crédits."
      },
      link: {
        menuLink: "Relier à un extra…",
        menuUnlink: "Détacher l'extra (le conserver)",
        link: "Relier…",
        unlink: "Détacher…",
        title: "Relier à un extra existant",
        subtitle: "extras et crédits libres du projet",
        search: "Rechercher par n° ou titre…",
        empty: "Aucun extra libre dans ce projet.",
        noMatch: "Aucun extra ne correspond à la recherche.",
        loadError: "Les extras n'ont pas pu être chargés.",
        confirm: "Relier",
        linking: "Liaison…",
        linkedToast: "Extra {label} relié à la directive",
        selected: "Sélection : {label}",
        alreadyLinked: "Cet extra vient d'être relié à une autre directive. Choisissez-en un autre.",
        error: "Le lien n'a pas pu être enregistré.",
        unlinkTitle: "Détacher l'extra",
        unlinkMessage: "L'extra {number} sera détaché de cette directive, mais conservé. La directive repassera à « À évaluer ».",
        unlinkConfirm: "Détacher",
        unlinkedToast: "Extra détaché de la directive (conservé)",
        unlinkError: "Le lien n'a pas pu être retiré."
      },
      filters: {
        button: "Filtres",
        buttonCount: "Filtres · {count}",
        status: "Statut",
        professional: "Professionnel",
        division: "Division",
        period: "Période de réception",
        allStatuses: "Tous les statuts",
        overdue: "À évaluer en retard",
        allProfessionals: "Tous les professionnels",
        allDivisions: "Toutes les divisions",
        from: "du",
        to: "au",
        reset: "Réinitialiser",
        shown: "{shown} sur {total}",
        noResults: "Aucune directive ne correspond aux filtres."
      },
      rules: {
        title: "Règles métier",
        r1: "L'onglet Directives contient seulement les directives reçues des professionnels.",
        r2: "Les soumissions des sous-traitants et les ordres de changement vont dans l'extra lié.",
        r3: "Chaque directive finit en extra, en crédit ou « Sans impact ».",
        r4: "Une directive « À évaluer » depuis {days} jours ou plus est signalée en retard."
      },
      updatedToast: "Directive mise à jour",
      outcomeChangedToast: "Issue modifiée",
      deletedToast: "Directive supprimée",
      detachError: "Issue enregistrée, mais l'extra {number} n'a pas pu être détaché."
    }
  },
  subInvoices: {
    resetToReceived: {
      paymentTitle: 'Paiement déjà enregistré',
      paymentMessage: 'Cette facture est déjà attachée à un paiement. Voulez-vous radier le(s) paiement(s) et remettre la facture comme non payée à 100 % ?',
      irreversible: 'Cette action est irréversible.',
      approvalTitle: 'Facture approuvée',
      approvalMessage: 'Cette facture est approuvée (net {net}). Annuler l\'approbation et la remettre à reçue ?',
      invoiceLabel: 'Facture {number}',
      noNumber: 'sans numéro',
      paymentLine: 'Chèque {check} · {amount} · {date}',
      paymentLineNoCheck: 'Paiement · {amount} · {date}',
      approvalLine: 'Approuvée · net {net}',
      confirm: 'Oui',
      cancel: 'Non',
      error: 'Échec de la remise à reçue — liste rechargée.',
      statusError: 'Échec du changement de statut — liste rechargée.'
    },
    overBudget: "Hors budget",
    clearFilters: "Effacer les filtres",
    filters: {
      searchPlaceholder: "Rechercher par nom ou n° de facture…",allStatuses: "Tous les statuts",withBalance: "Avec solde",chooseSubcontract: "— Choisir un sous-traitant —",allDp: "Tous les DP",noDp: "Sans DP"
    },
    toast: {
      markedPaid: "Marquée payée",
      updated: "Mise à jour"
    },
    export: {
      columns: {
        invoiceNumber: "N° facture",
        date: "Date",
        subcontractor: "Sous-traitant",
        type: "Type",
        amountTaxIn: "Montant (taxes incl.)",
        balance: "Solde",
        status: "Statut"
      }
    },
    title: 'Factures reçues',
    subtitle: 'Gérer les factures, approbations et paiements des sous-traitants',
    kpi: {
      totalInvoices: 'Total factures',
      totalInvoiced: 'Total facturé',
      approvedToPay: 'Approuvé à payer',
      paid: 'Payé'
    },
    tabs: {
      invoices: 'Factures',
      approval: 'Approbation des factures',
      payments: 'Paiements',
      summary: "Sommaire sous-traitant"
    },
    summaryTab: {
      title: "Sommaire financier",
      revisedContract: "Contrat révisé",
      selectPrompt: "Sélectionnez un sous-traitant pour voir son sommaire financier",
      selectHint: "La valeur du contrat, les avenants, les montants facturés et le solde restant apparaîtront ici",
      loading: "Chargement du sommaire financier…",
      contractValue: "Valeur du contrat",
      approvedExtras: "Extras approuvés",
      showBreakdown: "Afficher le détail",
      hideBreakdown: "Masquer le détail",
      credits: "Crédits",
      totalInvoiced: "Total facturé",
      overbilled: "Surfacturé",
      remainingToBill: "Reste à facturer",
      billingProgress: "Progression de facturation",
      signedChangeOrders: "Avenants signés",
      noSignedChangeOrder: "Aucun avenant signé",
      changeOrderLabel: "Avenant {n}"
    },
    toolbar: {
      invoices: 'factures',
      invoice: 'facture',
      addInvoice: 'Ajouter une facture'
    },
    table: {
      number: '#',
      subcontractor: 'Sous-traitant',
      invoiceNumber: 'Facture #',
      invoiceType: 'Type de facture',
      received: 'Reçu',
      total: 'Total',
      status: 'Statut',
      approvedPercent: 'Approuvé %',
      netPayable: 'Net à payer',
      created: 'Créé',
      actions: 'Actions',
      approvedAmount: 'Montant approuvé',
      retainage: 'Retenue',
      amountPaid: 'Montant payé',
      paidDate: 'Date de paiement',
      method: 'Méthode',
      reference: 'Référence',
      date: 'Date',
      amountTaxIn: 'Montant (taxes incl.)',
      balance: 'Solde'
    },
    status: {
      received: 'Reçue',
      pending_approval: 'Soumis',
      approved_to_pay: 'Approuvé à payer',
      partially_paid: 'Partiellement payé',
      paid: 'Payée',
      rejected: 'Rejetée',
      to_assign: 'À assigner',
      draft: 'Brouillon',
      sent: 'Envoyé',
      signed: 'Signé',
      completed: 'Complété',
      cancelled: 'Annulé',
      retentionToRelease: 'Retenue à libérer'
    },
    actions: {
      submitForApproval: 'Soumettre pour approbation',
      approveInvoice: 'Approuver la facture',
      recordPayment: 'Enregistrer un paiement',
      payRetention: 'Payer la retenue',
      releaseRetention: 'Libérer la retenue',
      delete: 'Supprimer'
    },
    empty: {
      noInvoices: 'Aucune facture sous-traitant',
      clickToAdd: 'Cliquez sur "Ajouter une facture" pour en créer une',
      noPending: 'Aucune facture en attente d\'approbation',
      pendingHint: 'Soumettez des factures pour approbation depuis l\'onglet Factures',
      pendingApprovalSuffix: 'en attente d\'approbation',
      noPayments: 'Aucun paiement enregistré',
      paymentsHint: 'Les factures approuvées apparaîtront ici pour paiement'
    },
    selectSubcontract: 'Sélectionner un sous-traitant',
    emptyTitle: 'Sélectionnez un sous-traitant pour voir ses factures',
    emptySubtitle: 'Choisissez un sous-traitant ci-dessus pour filtrer la liste des factures.',
    addModal: {
      title: 'Ajouter une facture sous-traitant',
      subcontractorLabel: 'Sous-traitant *',
      subcontractorPlaceholder: 'Sélectionner un sous-traitant...',
      invoiceNumberLabel: 'Numéro de facture',
      invoiceDateLabel: 'Date de facture',
      receivedDateLabel: 'Date de réception',
      notesLabel: 'Notes',
      notesPlaceholder: 'Notes facultatives...',
      linesLabel: 'Lignes de facture',
      addLine: 'Ajouter une ligne',
      addInvoice: 'Ajouter une facture',
      lineTypeCostCode: 'Code de coût',
      lineTypeExtra: 'Extra / Crédit',
      selectCostCode: 'Sélectionner un code de coût...',
      selectExtra: 'Sélectionner extra/crédit...',
      amountPlaceholder: 'Montant',
      descriptionPlaceholder: 'Description (facultatif)',
      invoiceTotal: 'Total facture',
      cancel: 'Annuler',
      save: 'Enregistrer la facture',
      saving: 'Enregistrement...',
      saveChanges: 'Enregistrer',
      errorSubcontractor: 'Veuillez sélectionner un sous-traitant.',
      errorLines: 'Ajoutez au moins une ligne de facture.',
      errorSubcontract: 'Veuillez sélectionner un sous-traitant.',
      errorExtraRequired: 'Veuillez sélectionner un extra.',
      errorCreditRequired: 'Veuillez sélectionner un crédit.',
      errorAmount: 'Toutes les lignes doivent avoir un montant > 0.',
      errorCostCode: 'Sélectionnez un code de coût pour chaque ligne.',
      errorExtra: 'Sélectionnez un extra/crédit pour chaque ligne extra.',
      errorSave: 'Échec de l\'enregistrement de la facture.'
    },
    invoiceType: {
      subcontract: 'Contractuel',
      extra: 'Extra',
      credit: 'Crédit'
    },
    approveModal: {
      title: 'Approuver la facture',
      invoiceNumber: 'Facture #',
      invoiceTotal: 'Total facture',
      holdbackLabel: 'Appliquer 10% de retenue',
      approvedAmount: 'Montant approuvé (100%)',
      retainage: 'Retenue',
      netPayable: 'Net à payer',
      paymentNoteLabel: 'Note de paiement (facultatif)',
      clientPaymentRequestNumber: 'Demande de paiement client #',
      enterClientPaymentRequestNumber: 'ex. 1001',
      cancel: 'Annuler',
      approve: 'Approuver à payer',
      approving: 'Approbation...',
      dpNotPaid: "La DP {number} n'est pas encore payée par le client.",
      approveAnyway: 'Approuver quand même',
      errorApprove: 'Échec de l\'approbation.',
      errorValidationNote: 'Expliquez pourquoi cette approbation est valide malgré le dépassement de la valeur acquise.',
      errorAcknowledge: 'Confirmez avoir pris connaissance du risque de surpaiement avant de continuer.',
      validation: {
        requiredClientPaymentRequestNumber: 'La demande de paiement client # est requise et doit être un entier positif.'
      }
    },
    paymentModal: {
      title: 'Enregistrer un paiement',
      invoiceTotalTaxIn: 'Total facture (taxes incl.)',
      approvedAmount: 'Montant approuvé',
      alreadyPaid: 'Total payé',
      remainingApproved: 'Approuvé restant',
      solde: 'Solde',
      remaining: 'Restant',
      checkNumberLabel: 'Chèque #',
      checkNumberPlaceholder: 'ex. 1042',
      amountPaidLabel: 'Montant payé',
      paidDateLabel: 'Date de paiement',
      methodLabel: 'Méthode',
      referenceLabel: 'Référence',
      referencePlaceholder: 'N° de réf.',
      cancel: 'Annuler',
      save: 'Enregistrer le paiement',
      saving: 'Enregistrement...',
      errorAmount: 'Le montant payé doit être supérieur à 0.',
      errorCheckNumber: 'Le numéro de chèque est requis.',
      errorReference: 'La référence est requise.',
      errorExceedsApproved: 'Le paiement ne peut pas dépasser le montant approuvé.',
      errorSave: 'Échec de l\'enregistrement du paiement.'
    }
  },
  factureApproval: {
    title: 'Approbation de facture',
    notFound: 'Facture introuvable.',
    noPdf: 'Aucun PDF lié',
    noPdfHint: 'Aucun document source trouvé pour cette facture.',
    summary: 'Résumé',
    invoiceDate: 'Date',
    subtotal: 'Sous-total',
    tps: 'TPS',
    tvq: 'TVQ',
    totalTaxIn: 'Total (taxes incl.)',
    linkedDp: 'DP liée',
    retentionIncludedBadge: 'Retenue incluse par le sous-traitant à la saisie',
    retentionExcludedBadge: 'Retenue exclue à la saisie',
    noteLabel: 'Note',
    notePlaceholder: 'Ajouter une note...',
    approvalControls: "Contrôles d\'approbation",
    applyRetentionLabel: 'Appliquer la retenue',
    retentionPctLabel: 'Retenue (%)',
    approveButton: 'Approuver à payer',
    back: 'Retour',
    invoiceLabel: 'Facture',
    retentionRelease: {
      title: 'Libération de la retenue',
      retentionToRelease: 'Retenue à libérer',
      remaining: 'Reste à payer',
      noContract: "Cette facture n'est pas rattachée à un contrat — libération impossible ici.",
      quittanceRequired: 'Quittance finale signée requise pour libérer la retenue.',
      quittanceLink: 'Ouvrir Dénonciations & Quittances',
      approveButton: 'Approuver le paiement de la retenue',
      releasing: 'Libération...',
      confirmTitle: 'Libérer la retenue ?',
      confirmMessage: 'Confirme que tu as reçu tous les documents requis pour la libération de la retenue.',
      confirmButton: 'Confirmer',
      error: 'Erreur lors de la libération de la retenue.'
    }
  },
  expenses: {
    title: 'Dépenses',
    subtitle: 'Suivre les dépenses du projet par code de coût',
    addExpense: 'Ajouter une dépense',
    kpi: {
      totalExpenses: 'Total des dépenses',
      totalAmount: 'Montant total',
      approved: 'Approuvé',
      paid: 'Payé'
    },
    toolbar: {
      expenses: 'dépenses',
      expense: 'dépense',
      searchPlaceholder: 'Rechercher une dépense…',
      exportCsvTooltip: 'Exporter toutes les lignes visibles en CSV',
      exportPdfTooltip: 'Exporter toutes les lignes visibles en PDF'
    },
    table: {
      date: 'Date',
      vendor: 'Fournisseur',
      description: 'Description',
      division: 'Division',
      costCode: 'Code de coût',
      costItem: 'Poste de coût',
      dp: 'DP',
      amount: 'Montant',
      status: 'Statut',
      actions: 'Actions',
      extraBadge: 'Extra',
      taxPrefix: 'taxes :'
    },
    status: {
      draft: 'Brouillon',
      approved: 'Approuvé',
      paid: 'Payé'
    },
    empty: {
      noExpenses: 'Aucune dépense pour le moment',
      clickToAdd: 'Cliquez sur "Ajouter une dépense" pour commencer'
    },
    modal: {
      addTitle: 'Ajouter une dépense',
      editTitle: 'Modifier la dépense',
      dateLabel: 'Date',
      vendorLabel: 'Fournisseur',
      vendorPlaceholder: 'ex. Home Depot',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'ex. Bois et fixations',
      divisionLabel: 'Division',
      divisionPlaceholder: 'Sélectionner une division...',
      costCodeLabel: 'Code de coût',
      costCodePlaceholder: 'Sélectionner un code de coût...',
      extraLabel: 'Extra / Crédit (optionnel)',
      extraPlaceholder: 'Sélectionner un extra/crédit...',
      amountLabel: 'Montant',
      tpsLabel: 'TPS',
      tvqLabel: 'TVQ',
      totalLabel: 'Total (calculé automatiquement)',
      referenceLabel: 'Référence #',
      referencePlaceholder: 'ex. FAC-001',
      statusLabel: 'Statut',
      paidByLabel: 'Payé par',
      paidByPlaceholder: 'Sélectionner le mode de paiement',
      addExpense: 'Ajouter la dépense',
      dpLabel: 'DP',
      dpNoneOption: '— Aucun —',
      dpApproved: 'approuvée',
      dpSubmitted: 'soumise',
      divisionGroupConstruction: 'Coût de construction',
      divisionGroupGeneral: 'Coût général',
      divisionGroupAdmin: 'Admin & Profit',
      extraOptionPrefix: 'Extra',
      paidByCheque: 'Chèque',
      prefilledFromInbox: 'Pré-rempli à partir du document de la boîte de réception'
    },
    validation: {
      dateRequired: 'Veuillez sélectionner une date.',
      vendorRequired: 'Le fournisseur est requis.',
      amountRequired: 'Le montant doit être supérieur à 0.',
      costCodeOrExtraRequired: 'Veuillez sélectionner un code de coût ou un extra.',
      saveFailed: 'Échec de l\'enregistrement de la dépense.',
      paymentRequestRequired: 'Sélectionnez une demande de paiement'
    },
    rowActions: {
      documents: 'Documents',
      actions: 'Actions',
      edit: 'Modifier',
      delete: 'Supprimer',
      noDocuments: 'Aucun document',
      moreDocuments: '+{count} de plus'
    },
    bulk: {
      selected: '{count} sélectionnée(s)',
      exportCsv: 'Exporter CSV',
      exportPdf: 'Exporter PDF',
      clear: 'Effacer'
    },
    inbox: {
      bannerLabel: 'Document préchargé depuis la boîte de réception :',
      documentFallback: 'Document'
    },
    delete: {
      title: 'Supprimer la dépense',
      message: 'Êtes-vous sûr ? Cette action est irréversible.'
    },
    export: {
      reportTitle: 'Rapport de dépenses',
      badge: 'Dépenses',
      generated: 'Généré le {date}',
      countOne: '{count} dépense',
      countMany: '{count} dépenses',
      grandTotal: 'Total général',
      projectFallback: 'Projet',
      selectedSuffix: 'Sélection',
      columns: {
        number: '#',
        date: 'Date',
        vendor: 'Fournisseur',
        description: 'Description',
        costItem: 'Poste de coût',
        amount: 'Montant',
        tax: 'Taxes',
        total: 'Total',
        status: 'Statut',
        paidBy: 'Payé par',
        reference: 'Référence'
      }
    }
  },
  extra: {
    enterAcceptedCostTitle: "Entrer le montant accepté de l\'extra",
    enterAcceptedCostTitleCredit: "Entrer le montant accepté du crédit",
    creditLabel: "Crédit",
    exportAcceptedNote: "Total accepté : extras et crédits approuvés uniquement.",
    selectSubcontractorRequired: "Sélectionner un sous-traitant",
    errorSubcontractorRequired: "Chaque groupe doit avoir un sous-traitant ou être marqué comme travaux internes",
    internalOnlyTitle: "Travaux internes",
    internalOnlyBody: "Cet extra ne contient aucune ligne de sous-traitant : aucun avenant n\'est nécessaire. L\'approbation enregistre le montant accepté sans engager de sous-traitant.",
    approveWithoutAvenant: "Approuver sans avenant",
    noLinesError: "Cet extra n\'a aucune ligne exploitable. Modifiez-le et attribuez un sous-traitant à chaque ligne, ou marquez-les comme travaux internes, puis réessayez.",
    enterAcceptedCostDescription: "Veuillez entrer le coût accepté avant d\'approuver cet extra.",
    extraLabel: "Extra",
    coLabel: "No CO",
    submittedCost: "Coût soumis",
    acceptedCost: "Coût accepté",
    errorGreaterThanZero: "Veuillez entrer une valeur supérieure à 0."
  },
  documents: {
    delete: {
      title: "Supprimer le document",
      message: "Êtes-vous sûr de vouloir supprimer ce fichier ?",
      cancel: "Annuler",
      confirm: "Supprimer"
    },
    title: "Documents",
    subtitle: "Gérer les fichiers et dossiers du projet",
    searchPlaceholder: "Rechercher des documents...",
    foldersPanel: "Dossiers",
    newFolderShort: "Nouveau",
    noFoldersYet: "Aucun dossier",
    createFirstFolder: "Créer votre premier dossier",
    selectAFolder: "Sélectionnez un dossier",
    selectFolderToViewFiles: "Sélectionnez un dossier pour voir les fichiers",
    uploadFile: "Téléverser un fichier",
    uploading: "Téléversement…",
    noFilesYet: "Aucun fichier",
    uploadToGetStarted: "Téléversez un fichier pour commencer",
    noDocumentsAttached: "Aucun document joint",
    loading: "Chargement des pièces…",
    duplicateName: "Un document nommé « {name} » existe déjà.",
    duplicatesSkipped: "Ignorés, déjà joints : {names}",
    uploadProgress: "{done} sur {total} téléversés",
    done: "Terminé",
    deleteFileAction: "Supprimer le fichier",
    dropFilesPrefix: "Déposez vos fichiers ici ou",
    dropFilesAction: "cliquez pour téléverser",
    supportedFormats: "PDF, Excel, Word acceptés · Max 20 Mo chacun",
    errorDeleting: "Erreur inattendue lors de la suppression du fichier.",
    errorOpening: "Erreur inattendue lors de l'ouverture du fichier.",
    errorCouldNotDelete: "Impossible de supprimer le fichier : {message}",
    errorCouldNotOpen: "Impossible d'ouvrir le fichier : {message}",
    errorFileTooLarge: "Fichier trop volumineux (max 20 Mo)",
    errorUnexpected: "Erreur inattendue",
    renameAction: "Renommer",
    downloadAction: "Télécharger",
    deleteAction: "Supprimer",
    confirmAction: "Confirmer",
    cancelAction: "Annuler",
    preview: {
      download: "Télécharger",
      zoomIn: "Zoom avant",
      zoomOut: "Zoom arrière",
      loadingFile: "Chargement du fichier…",
      unableToLoad: "Impossible de charger le fichier",
      openInNewTab: "Ouvrir dans un nouvel onglet",
      notAvailable: "Aperçu non disponible",
      downloadFile: "Télécharger le fichier"
    },
    createFolder: {
      title: "Créer un dossier",
      subtitle: "Ajoutez un nouveau dossier pour organiser vos documents",
      nameLabel: "Nom du dossier",
      namePlaceholder: "ex. Plans, Permis, Rapports…",
      typeLabel: "Type de dossier",
      rootOption: "Nouveau dossier",
      subfolderOption: "Sous-dossier",
      insideLabel: "Dans :",
      selectFolderFirst: "Sélectionnez d'abord un dossier pour créer un sous-dossier",
      submit: "Créer le dossier"
    },
    renameFolder: {
      title: "Renommer le dossier"
    },
    confirmDelete: {
      folderTitle: "Supprimer le dossier",
      fileTitle: "Supprimer le fichier",
      folderMessage: "Cette action supprimera définitivement le dossier et tout son contenu.",
      fileMessage: "Cette action supprimera définitivement le fichier."
    }
  },
  changeOrders: {
    delete: {
      title: "Supprimer l\'avenant",
      message: "Êtes-vous sûr de vouloir supprimer cet avenant ? Cette action est irréversible.",
      confirm: "Supprimer",
      cancel: "Annuler"
    },
    kpi: {
      total: "Total avenants",
      pending: "En attente (envoyés)",
      approved: "Approuvés",
      approvedAmount: "Montant approuvé",
    },
    filters: {
      allStatuses: "Tous les statuts"
    },
    addButton: "Ajouter un avenant",
    allSubcontractors: "Tous",
    unknownSubcontractor: "Inconnu",
    table: {
      coNumber: "No sous-contrat",
      subcontractor: "Sous-traitant",
      nCo: "# Directive",
      avenantTitle: "Titre de l\'avenant",
      amount: "Montant",
      status: "Statut",
      notes: "Notes",
      actions: "Actions",
    },
    status: {
      draft: "Brouillon",
      sent: "Envoyé",
      signed: "Signé",
      rejected: "Refusé",
    },
    actions: {
      changeStatus: "Changer le statut",
      actions: "Actions",
      documents: "Documents",
      deleteFile: "Supprimer le fichier",
      editNote: "Modifier la note",
      addNote: "Ajouter une note",
    },
    documents: {
      panelTitle: "Documents",
      none: "Aucun document",
      noneAttached: "Aucun document joint",
      uploading: "Téléversement…",
    },
    empty: {
      title: "Aucun avenant",
      hint: "Cliquez sur « + Ajouter un avenant » pour en créer un",
    },
  },
  subcontracts: {
    delete: {
      title: "Supprimer le contrat",
      message: "Êtes-vous sûr de vouloir supprimer ce contrat ? Cette action est irréversible.",
      confirm: "Supprimer",
      cancel: "Annuler",
      label: "Contrat",
      blockedTitle: "Suppression impossible",
      blockedIntro: "Ce contrat est relié à des éléments existants. Supprimez-les ou détachez-les d'abord.",
      blockedClose: "Fermer",
      blockedAvenants: "{count} avenant(s)",
      blockedSubInvoices: "{count} facture(s) sous-traitant",
      blockedSubInvoiceLines: "{count} ligne(s) de facture",
      blockedExtras: "{count} extra(s)",
      blockedExtraLines: "{count} ligne(s) d'extra",
      blockedCorrections: "{count} correction(s) de code de coût",
      blockedQuittances: "{count} quittance(s)",
      checking: "Vérification des liens…",
      success: "Contrat supprimé",
      error: "Impossible de supprimer le contrat. Veuillez réessayer."
    }
  },
  changeOrder: {
    note: {
      title: "Note d\'avenant",
      placeholder: "Ajouter une note pour cet avenant..."
    },
    page: {
      title: "Avenants",
      subtitle: "Suivi des avenants de sous-traitance"
    },
    detail: {
      title: "Détail de l\'avenant",
      view: "Voir le détail",
      subtotal: "Sous-total",
      tps: "TPS (5%)",
      tvq: "TVQ (9,975%)",
      total: "Total",
      notes: "Notes",
      close: "Fermer"
    }
  },
  avenants: {
    filteredBySubcontract: "Filtré par sous-traitant",
    clearFilter: "Effacer le filtre",
    detail: {
      title: "Détail de l\'avenant",
      view: "Voir le détail",
      subtotal: "Sous-total",
      tps: "TPS (5%)",
      tvq: "TVQ (9,975%)",
      total: "Total",
      notes: "Notes",
      close: "Fermer",
      subcontractor: "Sous-traitant",
      coNumber: "N° d\'avenant",
      sourceExtra: "Extra source",
      directive: "Directive",
      directiveNumber: "Numéro de directive",
      avenantTitle: "Titre de l\'avenant",
      description: "Description",
      status: "Statut",
      eyebrow: "Avenant",
      editMode: "Modification",
      infoSection: "Informations",
      contentSection: "Contenu",
      amountSection: "Montant",
      category: "Catégorie",
      subcontractPlaceholder: "Choisir un sous-contrat…",
      descriptionPlaceholder: "Décrire l\'avenant…",
      subcontractRequired: "Le sous-contrat est requis",
      amountRequired: "Montant valide requis",
      saveError: "Impossible d\'enregistrer l\'avenant.",
      save: "Enregistrer",
      saving: "Enregistrement…",
      discardTitle: "Abandonner les modifications ?",
      discardMessage: "Les changements non enregistrés seront perdus.",
      discardConfirm: "Abandonner",
      keepEditing: "Continuer la modification",
      division: "Division",
      inherited: "Hérité de l\'extra source",
      subcontractLocked: "Verrouillé : l\'avenant est envoyé ou signé.",
      statusLabels: {
        draft: "Brouillon",
        sent: "Envoyé",
        signed: "Signé",
        rejected: "Rejeté"
      }
    },
    form: {
      addTitle: "Nouvel avenant",
      editTitle: "Modifier l\'avenant",
      addSubtitle: "Créer un nouvel avenant de sous-traitance",
      editSubtitle: "Mettre à jour les détails de l\'avenant",
      create: "Créer l\'avenant",
      saveChanges: "Enregistrer les modifications",
      sourceInfo: "Info de l\'extra source",
      sourceExtraTitle: "Titre de l\'extra source",
      directive: "Directive",
      directiveNumber: "Numéro de directive (client)",
      category: "Catégorie"
    }
  },
  paymentRequests: {
    errors: {
      saveBeforeAttach: "Enregistrez d\'abord la demande pour y joindre des documents."
    },
    title: "Demandes de paiement",
    subtitle: "Gérer les demandes de paiement client",
    exportExcel: "Excel",
    addRequest: "Ajouter une demande",
    searchPlaceholder: "Rechercher des demandes...",
    kpi: {
      totalRequests: "Total demandes",
      totalValue: "Valeur totale",
      invoiced: "Facturées",
      paid: "Payées",
    },
    table: {
      requestNumber: "Demande #",
      date: "Date",
      status: "Statut",
      totalAmount: "Montant total",
      beforeTax: "Avant taxes",
      modifiedBy: "Modifié par",
      lastModified: "Dernière modification",
      actions: "Actions",
      rowSubtitle: "Demande de paiement",
      paidOn: "Reçu le {date}",
      billing: "Facturation"
    },
    actions: {
      edit: "Modifier",
      delete: "Supprimer",
      viewDocuments: "Voir les documents"
    },
    modal: {
      titleCreate: "Nouvelle demande de paiement",
      titleEdit: "Modifier la demande de paiement",
      dp1Notice: "Première demande — définir les lignes de base",
      dp2Notice: "Demande suivante — montants précédents verrouillés",
      baseLines: "Lignes contractuelles",
      extrasSection: "Extras",
      addLine: "+ Ajouter une ligne",
      addExtraLine: "+ Ajouter un extra",
      description: "Description",
      contractAmount: "Montant contractuel",
      percent: "%",
      valueToDate: "Valeur à ce jour",
      previous: "Précédent",
      thisRequest: "Cette demande",
      documents: "Documents (optionnel)",
      dropFilesHere: "Déposez les fichiers ici ou cliquez pour téléverser",
      summary: "Sommaire",
      subtotal: "Sous-total",
      retention: "Retenue ({rate}%)",
      applyHoldback: "Appliquer la retenue de 10 %",
      subtotalAfterHoldback: "Sous-total après retenue",
      tps: "TPS (5%)",
      tvq: "TVQ (9,975%)",
      total: "Total",
      contractTotal: "Total contractuel",
      extrasTotal: "Total extras",
      revisedContract: "Contrat révisé",
      baseContractAmount: "Montant contractuel de base",
      approvedExtras: "Extras approuvés",
      revisedContractAmount: "Montant du contrat révisé",
      cancel: "Annuler",
      save: "Enregistrer",
      saving: "Enregistrement...",
      statusLabel: "Statut",
      periodSection: "Période",
      periodStartLabel: "Date de début de période",
      periodEndLabel: "Date de fin de période",
      periodInvalid: "La date de fin doit être après la date de début"
    },
    status: {
      draft: "Brouillon",
      submitted: "Soumis",
      approved: "Approuvé",
      paid: "Paiement reçu"
    },
    billing: {
      notInvoiced: "Non facturée",
      invoiced: "Facturée",
      paid: "Payée",
      markInvoiced: "Marquer facturée",
      markPaid: "Paiement reçu"
    },
    invoiceDialog: {
      title: "Facturer — DP-{number}",
      number: "Numéro de facture",
      date: "Date de facturation",
      numberRequired: "Entrez le numéro de facture.",
      dateRequired: "Entrez la date de facturation.",
      error: "La facturation n'a pas été enregistrée. Réessayez.",
      cancel: "Annuler",
      confirm: "Enregistrer"
    },
    paidDialog: {
      title: "Paiement reçu — DP-{number}",
      date: "Date de réception",
      amount: "Montant reçu (facultatif)",
      dateRequired: "Entrez la date de réception.",
      amountInvalid: "Montant invalide.",
      error: "Le statut n'a pas été enregistré. Réessayez.",
      cancel: "Annuler",
      confirm: "Enregistrer"
    },
    validation: {
      negativeValue: "La valeur ne peut pas être négative",
      exceedsContract: "Ne peut pas dépasser le montant contractuel",
      descriptionRequired: "La description est requise"
    },
    extras: {
      selectExtra: "Sélectionner un extra approuvé...",
      credit: "Crédit",
      alreadySubmitted: "Déjà soumis dans une demande précédente"
    },
    view: {
      title: "DEMANDE DE PAIEMENT",
      period: "Période",
      amounts: "Montants",
      amountBeforeTax: "Montant sans taxes",
      close: "Fermer",
      exportPdf: "Exporter PDF",
      exportExcel: "Excel",
    },
    empty: "Aucune demande de paiement. Cliquez sur \"+ Ajouter une demande\" pour créer la première.",
    deleteBlockedTitle: "Impossible de supprimer",
    deleteBlockedMessage: "{invoices} facture(s) et {expenses} dépense(s) sont liées à cette DP — reliez-les à une autre DP avant de supprimer.",
    deleteBlockedApproved: "La DP{number} est approuvée — elle est fermée et ne peut pas être supprimée.",
    deleteBlockedNewerExists: "Impossible de supprimer la DP{number} : une demande plus récente existe (DP{max}). Supprimez d'abord les demandes suivantes.",
    deleteConfirmTitle: "Supprimer la DP{number} ?",
    deleteConfirmMessage: "Les lignes que vous avez ajoutées à cette demande de paiement seront supprimées. Cette action est irréversible.",
    deleteFailed: "Impossible de supprimer cette demande de paiement. Réessayez.",
    editBlockedApproved: "La DP{number} est approuvée — elle est fermée (lecture seule) et ne peut pas être modifiée.",
    closedReadOnly: "Fermée — lecture seule",
    saveBlockedApproved: "Cette demande de paiement est approuvée et ne peut pas être modifiée.",
    blockedCreate: {
      title: "Demande précédente incomplète",
      message: "La demande DP{number} est encore en brouillon. Veuillez la soumettre ou l'approuver avant de créer une nouvelle demande.",
      close: "Fermer"
    },
    approveRequest: {
      title: "Approuver la demande DP{number}",
      downloadUnsigned: "Télécharger le PDF (non signé)",
      dropZoneLabel: "Déposez ici le PDF signé par le client/professionnel",
      dropZoneHint: "Cliquez ou glissez-déposez — PDF uniquement",
      pdfOnly: "Seuls les fichiers PDF sont acceptés.",
      approve: "Approuver",
      error: "Une erreur est survenue. La demande n\'a pas été approuvée."
    },
    toolbar: {
      downloadDetail: "Télécharger détail",
      downloadDetailCount: "Télécharger détail ({count})",
      selectARequest: "Sélectionnez une demande",
      exportDetailExcel: "Exporter DP{number} en Excel",
      exportPdf: "Exporter en PDF"
    },
    export: {
      projectFallback: "Projet",
      exportedOn: "Exporté le {date}",
      totalItems: "Total ({count} éléments)",
      columns: {
        requestNumber: "Demande #",
        date: "Date",
        total: "Total",
        status: "Statut"
      }
    },
    excelDetail: {
      sheetName: "Demande de paiement",
      projectLabel: "Projet",
      clientLabel: "Client",
      contractorLabel: "Entrepreneur",
      periodLabel: "Période",
      contractLines: "Lignes contractuelles",
      extras: "Extras",
      summary: "Sommaire",
      total: "TOTAL",
      uploadFailed: "Échec du téléversement",
      columns: {
        description: "Description",
        contractAmount: "Montant contrat",
        previous: "Précédent",
        thisRequest: "Cette demande",
        monthly: "Mensuel"
      }
    },
    pdf: {
      title: "DEMANDE DE PAIEMENT",
      sections: {
        project: "PROJET",
        client: "CLIENT",
        detail: "DÉTAIL",
        totals: "TOTAUX"
      },
      columns: {
        description: "Description",
        contractAmount: "Montant contrat",
        previous: "Précédent",
        thisMonth: "Ce mois",
        toDate: "Cumulatif"
      },
      totals: {
        subtotal: "Sous-total",
        holdback: "Retenue (10%)",
        subtotalAfterHoldback: "Sous-total après retenue",
        tps: "TPS (5%)",
        tvq: "TVQ (9,975%)",
        netTotal: "Total net"
      }
    }
  },
  invoiceInbox: {
    title: "Boîte des factures",
    subtitle: "Téléverser et gérer les factures entrantes",
    uploadButton: "Téléverser une facture",
    uploading: "Téléversement...",
    searchPlaceholder: "Rechercher par nom de fichier...",
    noInvoicesTitle: "Aucune facture trouvée",
    noInvoicesSubtitle: "Téléversez un PDF pour commencer",
    noFileUrl: "Aucune URL de fichier disponible",
    loadingDocument: "Chargement du document...",
    unableToLoad: "Impossible de charger le document",
    unableToLoadSub: "Le fichier ne peut pas être affiché dans le visualiseur",
    downloadFile: "Télécharger le fichier",
    openInNewTab: "Ouvrir dans un nouvel onglet",
    uploadError: "Échec du téléversement",
    deleteErrors: {
      notPermitted: "Suppression refusée : votre compte n'a pas le droit de supprimer des entrées de la boîte de réception. L'entrée est toujours là.",
      partial: "{deleted} entrée(s) supprimée(s), {failed} refusée(s). Les entrées refusées restent sélectionnées.",
      failed: "La suppression a échoué. L'entrée n'a pas été supprimée."
    },
    invoiceCreated: "Créée",
    invoiceCount: "{count} facture",
    invoiceCountPlural: "{count} factures",
    upload: {
      done: "Téléversement terminé",
      inProgress: "Téléversement des factures...",
      accepted: "{count} acceptée(s)",
      rejected: "{count} rejetée(s)",
      addedOne: "1 facture ajoutée",
      added: "{count} factures ajoutées",
      skippedOne: "1 ignorée (doublon)",
      skipped: "{count} ignorées (doublons)",
      processing: "Traitement de {current} sur {total}...",
      skippedTitle: "Fichiers ignorés",
      reason: {
        duplicate: "Existe déjà"
      }
    },
    filter: {
      title: "Filtrer",
      invoicesLabel: "factures",
      inbox: "Boîte (Nouveau)",
      all: "Tout",
      new: "Nouveau",
      ready: "Prêt",
      created: "Créée",
      uploaderMine: "Mes factures",
      uploaderAll: "Tous les téléverseurs"
    },
    columns: {
      file: "Fichier",
      supplier: "Fournisseur",
      date: "Date",
      amount: "Montant",
      status: "Statut"
    },
    status: {
      new: "Nouveau",
      ready: "Prêt",
      created: "Créée"
    },
    form: {
      createInvoice: "Créer une facture",
      cancel: "Annuler",
      panelTitle: "Créer une facture",
      prevInvoice: "Facture précédente",
      nextInvoice: "Facture suivante",
      reRunExtraction: "Relancer l\'extraction IA",
      remainingLeft: "{count} restante(s)",
      ai: {
        extractionInProgress: "Extraction IA en cours…",
        extractionSubtitle: "Lecture du document et extraction des données… Cela peut prendre quelques secondes.",
        matchingSupplier: "Correspondance IA du fournisseur avec les sous-traitants...",
        matchingCostCode: "Sélection IA du meilleur code de coût pour ce corps de métier...",
        supplierLabel: "Fournisseur :",
        matchedLabel: "Associé :",
        confidenceLabel: "{pct} % de confiance",
        possibleMatch: "Correspondance possible ({pct} %) :",
        acceptMatch: "Accepter cette correspondance",
        amountDetected: "Montant détecté :",
        fieldsPreFilled: "Champs pré-remplis depuis le document — vérifiez avant de soumettre.",
        extractionFailed: "L'IA n'a pas pu extraire les données de ce document. Veuillez remplir les champs manuellement.",
        reExtractionFailed: "La ré-extraction a échoué. Veuillez remplir les champs manuellement."
      },
      project: {
        label: "Projet",
        autoSelected: "Auto-sélectionné",
        placeholder: "— Sélectionner un projet —",
        loading: "Chargement des données du projet..."
      },
      typeToggle: {
        label: "Type",
        invoice: "Facture",
        expense: "Dépense"
      },
      invoice: {
        subcontractLabel: "Sous-traitance",
        searchSubcontract: "Rechercher un sous-traitant...",
        searchExtras: "Rechercher des extras...",
        searchCredits: "Rechercher des crédits...",
        invoiceNumberLabel: "Facture #",
        invoiceNumberPlaceholder: "ex. FAC-2024-001",
        dpLabel: "DP",
        noneOption: "— Aucun —",
        dpApproved: "approuvée",
        dpSubmitted: "soumise",
        lineTypeCostCode: "Code de coût",
        lineTypeExtraCredit: "Extra / Crédit",
        subcontractOptional: "Sous-traitance",
        subcontractOptionalSuffix: "(optionnel)",
        selectSubcontractOptional: "Sélectionner un sous-traitant (optionnel)...",
        descriptionOptional: "Description (optionnelle)",
        notesLabel: "Notes",
        notesPlaceholder: "Notes optionnelles...",
        processingLabel: "Traitement…",
        retentionIncluded: "Retenue incluse",
        retentionIncludedHint: "Le sous-traitant a déjà inclus la retenue (10 %) dans sa facture.",
        applyRetention: "Appliquer la retenue",
        retentionPct: "Retenue (%)",
        approvedAmount: "Montant approuvé (100%)",
        retentionLine: "Retenue ({pct}%)",
        netPayable: "Net à payer"
      },
      expense: {
        vendorLabel: "Fournisseur",
        vendorPlaceholder: "ex. Home Depot",
        expenseDateLabel: "Date de la dépense",
        referenceLabel: "Référence #",
        referencePlaceholder: "ex. REC-001",
        amountLabel: "Montant",
        subtotalAfterHoldback: "Sous-total après retenue",
        tpsLabel: "TPS (5 %)",
        tvqLabel: "TVQ (9,975 %)",
        autoPlaceholder: "Auto",
        taxesIncluded: "Taxes incluses",
        taxesIncludedHint: "Le montant saisi inclut les taxes — le montant hors taxes est calculé automatiquement.",
        totalLabel: "Total",
        statusLabel: "Statut",
        statusPaid: "payé",
        statusPending: "en attente",
        statusApproved: "approuvé",
        divisionLabel: "Division",
        selectDivision: "— Sélectionner une division —",
        groupConstruction: "Coût de construction",
        groupGeneral: "Coût général",
        groupAdmin: "Admin & Profit",
        costCodeLabel: "Code de coût",
        selectCostCodePlaceholder: "— Sélectionner un code de coût —",
        selectDivisionFirst: "— Sélectionner une division d\'abord —",
        extraCreditLabel: "Extra / Crédit",
        optionalSuffix: "(optionnel)",
        paidByLabel: "Payé par",
        selectPlaceholder: "— Sélectionner —",
        descriptionLabel: "Description",
        descriptionPlaceholder: "Description optionnelle...",
        createExpenseButton: "Créer une dépense",
        dpLabel: "DP",
        dpNoneOption: "— Aucun —",
        dpApproved: "approuvée",
        dpSubmitted: "soumise"
      },
      errors: {
        selectProject: "Veuillez sélectionner un projet.",
        enterVendor: "Veuillez entrer un nom de fournisseur.",
        enterAmount: "Veuillez entrer un montant valide.",
        selectSubcontract: "Veuillez sélectionner un sous-traitant.",
        selectExtra: "Veuillez sélectionner un extra.",
        selectCredit: "Veuillez sélectionner un crédit.",
        addLine: "Veuillez ajouter au moins une ligne.",
        lineAmount: "Toutes les lignes doivent avoir un montant valide.",
        lineCostCode: "Veuillez sélectionner un code de coût pour chaque ligne.",
        lineExtraCredit: "Veuillez sélectionner un extra/crédit pour chaque ligne.",
        createExpense: "Échec de la création de la dépense.",
        createInvoice: "Échec de la création de la facture.",
                paymentRequestRequired: "Sélectionnez une demande de paiement"
      }
    },
    splitView: {
      unnamedFile: "Facture PDF",
      closePanel: "Fermer"
    }
  },
  duplicateInvoiceModal: {
    title: "Facture en double",
    message: "Une facture avec le même numéro existe déjà pour ce sous-traitant et ce projet.",
    existingLabel: "Celle qui existe déjà",
    incomingLabel: "Celle que vous allez détruire",
    invoiceNumber: "Facture #",
    date: "Date",
    status: "Statut",
    createdAt: "Créée le",
    amount: "Montant",
    subcontractor: "Sous-traitant",
    project: "Projet",
    fileLabel: "Fichier",
    receivedFrom: "Reçu de",
    receivedAt: "Reçu le",
    existingNotLoaded: "La facture existante n\'a pas pu être chargée. Vérifiez-la avant de supprimer quoi que ce soit.",
    cancel: "Annuler",
    viewExisting: "Voir l\'existante",
    delete: "Supprimer le document reçu"
  },
  duplicateExpenseModal: {
    title: "Doublon possible",
    message: "Une dépense avec le même numéro de référence et le même fournisseur existe déjà pour ce projet.",
    existingLabel: "Dépense existante :",
    invoiceNumber: "Référence #",
    date: "Date",
    amount: "Montant",
    vendor: "Fournisseur",
    cancel: "Annuler",
    saveAnyway: "Enregistrer quand même"
  },
  invoice: {
    form: {
      title: "Ajouter une facture",
      editTitle: "Modifier la facture",
      sectionDetails: "Détails de la facture",
      sectionNotes: "Notes",
      invoiceType: "Type de facture",
      subcontract: "Sous-traitance",
      extra: "Extra",
      credit: "Crédit",
      selectSubcontract: "Sélectionner un sous-traitant",
      invoiceNumber: "Numéro de facture",
      paymentRequest: "Demande de paiement",
      dpApproved: "approuvée",
      dpSubmitted: "soumise",
      invoiceDate: "Date de facture",
      receivedDate: "Date de réception",
      invoiceLines: "Lignes de facture",
      costCode: "Code de coût",
      selectCostCode: "Sélectionner un code de coût...",
      amount: "Montant",
      description: "Description (optionnelle)",
      subtotal: "Sous-total",
      grandTotal: "Total",
      applyTaxes: "Appliquer les taxes du Québec",
      cancel: "Annuler",
      save: "Enregistrer",
      addLine: "Ajouter une ligne"
    }
  },
  teamSchedule: {
    title: "Horaire des équipes",
    subtitle: "Qui travaille sur quel chantier, et quand.",
    today: "Aujourd'hui",
    previousMonth: "Mois précédent",
    nextMonth: "Mois suivant",
    allProjects: "Tous les projets",
    allTrades: "Tous les métiers",
    assign: "Assigner",
    addHere: "assigner",
    moreOthers: "+{count} autres",
    stats: {
      workers: "Travailleurs",
      people: "Personnes",
      personDays: "Jours-personnes",
      projects: "Chantiers couverts",
      unassigned: "Non assignés cette semaine",
    },
    groups: {
      workers: "Travailleurs",
      supervisors: "Surintendants",
    },
    view: {
      month: "Mois",
      week: "Semaine",
    },
    durations: {
      half: "4 h · demi-journée",
      full: "8 h · journée",
      custom: "Autre · je choisis la fin",
    },
    weekdays: {
      "0": "D",
      "1": "L",
      "2": "M",
      "3": "M",
      "4": "J",
      "5": "V",
      "6": "S",
    },
    result: {
      title: "Résultat",
      created: "{count} assignations créées",
      skipped: "{count} journées sautées — {worker} était déjà pris à ces heures-là :",
      alreadyAt: "déjà {time} au {project}",
    },
    modal: {
      createTitle: "Nouvelle assignation",
      editTitle: "Modifier l'assignation",
      worker: "Travailleur",
      workerPlaceholder: "Choisir un travailleur…",
      project: "Projet",
      projectPlaceholder: "Choisir un projet…",
      date: "Date",
      block: "Bloc",
      startTime: "Début",
      endTime: "Fin",
      note: "Note pour le travailleur",
      notePlaceholder: "Voici les tâches à faire…",
      when: "Quand",
      singleDay: "Un jour",
      multipleDays: "Plusieurs jours",
      fromDate: "Du",
      toDate: "Au",
      from: "De",
      to: "À",
      startTime: "Heure de début",
      duration: "Durée",
      weekendHint: "La fin de semaine est exclue par défaut.",
      summaryRange: "{count} journées · {start} → {end} chacune",
      createCount: "Créer {count} assignations",
      conflict: "{worker} est déjà assigné au {project} de {time} le {date}. Retire d'abord cette assignation, ou choisis une autre plage horaire.",
    },
    empty: {
      title: "Aucune personne à planifier",
      message: "Ajoute des employés avec le rôle Travailleur ou Surintendant dans Utilisateurs, puis reviens ici pour bâtir l'horaire.",
    },
    errors: {
      duplicate: "Cette personne a déjà ce bloc ce jour-là.",
      saveFailed: "L'enregistrement a échoué.",
      deleteFailed: "La suppression a échoué.",
      overlap: "Cette plage en recoupe une autre pour cette personne.",
      overlapRace: "Une autre saisie vient de réserver ces heures. Recharge la page et réessaie.",
      overlapNamed: "{worker} est déjà assigné au {project} de {time} le {date}.",
      checkFailed: "L'heure de fin doit être après l'heure de début.",
      forbidden: "Vous n'avez pas le droit de modifier cet horaire.",
      saveFailedCode: "L'enregistrement a échoué ({code}).",
      endBeforeStart: "L'heure de fin doit suivre l'heure de début.",
    },
  },
  schedule: {
    title: "Échéancier",
    reorder: {
      moveUp: "Monter",
      moveDown: "Descendre"
    },
    zoom: {
      today: "Aujourd'hui",
      day: "Jour",
      week: "Semaine",
      month: "Mois"
    },
    subtitle: "Planifier les sous-traitants et suivre l'avancement des travaux",
    viewGantt: "Gantt",
    viewWeek: "Semaine",
    addTask: "Ajouter une tâche",
    addSubtask: "Ajouter une sous-tâche",
    milestoneLabel: "Jalon",
    dependency: {
      deleteTitle: "Supprimer la dépendance",
      deleteMessage: "Voulez-vous supprimer cette dépendance entre les deux tâches ?",
      deleteConfirm: "Supprimer",
      type: "Type",
      types: {
        FS: "Fin → Début",
        FF: "Fin → Fin",
        SS: "Début → Début",
        SF: "Début → Fin",
      },
    },
    add: {
      task: "Tâche",
      milestone: "Jalon",
      section: "Section",
    },
    expandAll: "Déplier",
    collapseAll: "Replier",
    filter: "Filtre",
    sort: "Trier",
    export: "Export",
    comingSoon: "Bientôt disponible",
    zoomLabel: "Zoom",
    columns: "Colonnes visibles",
    colStart: "Date de début",
    colEnd: "Date de fin",
    colDuration: "Durée",
    colProgress: "% Avancement",
    progress: "Avancement",
    noTasks: "Aucune tâche",
    noTasksHint: "Cliquez sur « Ajouter une tâche » pour créer la première.",
    days: ["lun","mar","mer","jeu","ven","sam","dim"],
    table: {
      task: "Tâche",
      assigned: "Assigné à",
      status: "Statut",
      start: "Début",
      end: "Fin",
      duration: "Durée",
    },
    week: {
      previous: "Semaine précédente",
      next: "Semaine suivante",
      noWork: "Aucun travail",
      noSubcontractor: "Sans sous-traitant",
    },
    tooltips: {
      dragToConnect: "Glisser pour relier",
      clickToEdit: "Double-cliquer pour modifier",
      clickToEditDuration: "Double-cliquer pour modifier la durée",
      dragToResizeColumn: "Glisser pour redimensionner la colonne",
      dragToResizePanels: "Glisser pour redimensionner les panneaux",
      collapse: "Réduire",
      expand: "Déplier",
    },
    modal: {
      createTask: "Ajouter une tâche",
      createSubtask: "Ajouter une sous-tâche",
      editTask: "Modifier la tâche",
      subtaskOf: "Sous-tâche de :",
      parentTask: "Tâche parente",
      taskName: "Nom de la tâche",
      taskNamePlaceholder: "ex. Excavation des fondations",
      subcontractor: "Sous-traitant",
      startDate: "Date de début",
      endDate: "Date de fin",
      progress: "Avancement (%)",
      cancel: "Annuler",
      creating: "Création…",
      saving: "Enregistrement…",
      saveChanges: "Enregistrer les modifications",
      optional: "facultatif",
      milestone: "Jalon (durée 0)",
      milestoneTooltip: "Un jalon marque une date clé sans durée"
    },
    errors: {
      nameRequired: "Le nom de la tâche est requis.",
      startRequired: "La date de début est requise.",
      endRequired: "La date de fin est requise.",
      endBeforeStart: "La date de fin doit suivre la date de début.",
      unexpected: "Une erreur inattendue est survenue.",
      createFailed: "La création de la tâche a échoué.",
      updateFailed: "La mise à jour de la tâche a échoué."
    }
  },
  subcontractCombobox: {
    selectProjectFirst: "Sélectionnez d\'abord un projet"
  },
  expenseRedirect: {
    title: "Sélectionner un projet",
    subtitle: "Choisissez le projet auquel cette dépense appartient"
  },
  costCodeNote: {
    errors: {
      load: "Échec du chargement de la note.",
      save: "Échec de l\'enregistrement de la note. Réessayez."
    },
    title: "Note",
    placeholder: "Saisir l'analyse d'estimation, hypothèses, contexte...",
    cancel: "Annuler",
    save: "Enregistrer",
    saving: "Enregistrement...",
    iconTooltipAdd: "Ajouter une note d\'estimation",
    iconTooltipEdit: "Modifier la note d\'estimation"
  },
  projectTeam: {
    sectionTitle: "Équipe du projet",
    pm: "Chargé de projet",
    supervisor: "Surintendant",
    coordinator: "Coordonnateur",
    assistant: "Assistant(e)",
    selectUser: "Sélectionner un utilisateur...",
    noUsersAvailable: "Aucun utilisateur disponible",
    notAssigned: "Non assigné",
    picker: {
      placeholder: "Sélectionner un utilisateur...",
      searchPlaceholder: "Rechercher par nom ou courriel",
      noUsers: "Aucun utilisateur actif trouvé",
      loading: "Chargement des utilisateurs..."
    }
  },
  internal: {
    suffix: "(interne)"
  },
  projectWorkspace: {
    accessDenied: {
      title: "Projet introuvable ou accès refusé",
      message: "Ce projet n\'existe pas ou vous n\'avez pas la permission de le consulter. Contactez votre administrateur si vous pensez qu\'il s\'agit d\'une erreur.",
      backButton: "Retour à la liste des projets"
    }
  },
  dailyLog: {
    title: "Journaux de chantier",
    subtitle: "Suivez l\'activité et les conditions du chantier",
    newLog: "Nouveau journal",
    empty: "Aucun journal de chantier. Créez votre premier journal pour suivre l\'activité du chantier.",
    accessDenied: "Vous n\'avez pas accès aux journaux de chantier sur ce projet.",
    list: {
      date: "Date",
      createdBy: "Créé par",
      editedBy: "Dernière modification par",
      crewCount: "{count} corps de métier sur site",
      photosCount: "{count} photo(s)",
      moreCount: "+{count} de plus"
    },
    badge: {
      missing: "Journal manquant",
      missingDays: "Manquant {count} jours"
    },
    modal: {
      titleCreate: "Nouveau journal",
      titleEdit: "Modifier le journal",
      date: "Date",
      datePlaceholder: "Sélectionner une date",
      dateAlreadyExists: "Un journal existe déjà pour cette date",
      dateFuture: "La date ne peut pas être dans le futur.",
      dateLockedApproved: "Journal approuvé : retirez l'approbation pour changer la date.",
      dateBeforeSource: "Ce journal reprend des tâches du journal du {date} : sa date doit venir après.",
      dateAfterDependent: "Le journal du {date} reprend des tâches de celui-ci : sa date doit venir avant.",
      datePrefillReplace: "L'équipe et les tâches reportées dépendent de la date. Remplacer celles que vous avez saisies par celles du journal précédant cette date ?",
      datePrefillReplaceConfirm: "Remplacer",
      lastLog: "Dernier journal : {date}",
      noLogYet: "Aucun journal pour ce projet.",
      missingDays: "Jours ouvrables sans journal (30 derniers jours) : {dates}",
      save: "Enregistrer",
      cancel: "Annuler",
      saving: "Enregistrement..."
    },
    weather: {
      label: "Météo",
      condition: "Condition",
      conditionPlaceholder: "Sélectionner une condition",
      temperature: "Température (°C)",
      sunny: "Ensoleillé",
      cloudy: "Nuageux",
      rain: "Pluie",
      snow: "Neige",
      storm: "Orage",
      other: "Autre"
    },
    crew: {
      label: "Tâches",
      addCrew: "+ Ajouter une équipe",
      subcontractor: "Sous-traitant",
      subcontractorPlaceholder: "Sélectionner un sous-traitant",
      workerCount: "Nombre de travailleurs",
      notes: "Notes (optionnel)",
      remove: "Retirer",
      empty: "Aucune équipe ajoutée",
      sectionTitle: "ÉQUIPE SUR SITE",
      emptyState: "Aucun sous-traitant sur site ce jour-là",
      addSubcontractor: "+ Ajouter un sous-traitant",
      addTask: "+ Ajouter une tâche",
      noTasks: "Aucune tâche enregistrée",
      taskName: "Nom de la tâche",
      percentage: "%",
      notesLabel: "Notes",
      workerCountLabel: "Nombre d\'ouvriers",
      subcontractorLabel: "Sous-traitant",
      cardHeader: {
        workers: "ouvriers"
      }
    },
    workPerformed: "Travaux effectués",
    workPerformedPlaceholder: "Décrivez le travail effectué aujourd\'hui...",
    notes: "Notes",
    notesPlaceholder: "Notes supplémentaires, observations ou préoccupations...",
    photos: {
      label: "Photos",
      dropzone: "Déposez les photos ici ou cliquez pour téléverser",
      limit: "Jusqu'à 20 photos · JPEG, PNG, WebP · Max 20MB chacune",caption: "Légende (optionnel)",remove: "Retirer la photo",uploading: "Téléversement...",
      uploadingCount: "Téléversement de {count} photo(s)...",
      compressing: "Compression en cours...",
      fileTooLarge: "Le fichier dépasse la limite de 20 Mo et a été ignoré.",
      heicNotSupported: "Format HEIC non supporté sur ce navigateur, utilisez JPG."
    },
    kpi: {
      totalLogs: "Total des journaux",missingLogs: "Journaux manquants (30j)",awaitingApproval: "En attente d\'approbation"
    },
    table: {
      date: "Date",weather: "Météo",team: "Équipe",materials: "Matériaux",issues: "Enjeux",trades: "Corps de métier",workers: "Travailleurs",photos: "Photos",notes: "Notes",summary: "Résumé",author: "Auteur",approval: "Approbation",actions: "Actions",edited: "Modifié",noLogs: "Aucun journal ne correspond aux filtres"
    },
    filters: {
      dateFrom: "Du",dateTo: "Au",weather: "Météo",author: "Auteur",allWeather: "Toutes",allAuthors: "Tous",approval: "Approbation",allApproval: "Tous les états",clear: "Effacer les filtres"
    },
    actions: {
      view: "Voir",edit: "Modifier",delete: "Supprimer"
    },
    approval: {
      submitted: "Soumis",approved: "Approuvé",markApproved: "Marquer comme approuvé",markSubmitted: "Marquer comme soumis",toastApproved: "Journal approuvé",toastUnapproved: "Approbation retirée"
    },
    view: {
      title: "Journal de chantier",weather: "Météo",crew: "Équipe sur site",crewTotal: "Total: {trades} corps de métier, {workers} travailleur(s)",
      workPerformed: "Travaux effectués",notes: "Notes",photos: "Photos ({count})",createdBy: "Créé par {author} le {date}",editedBy: "Dernière modification par {editor} le {date}",approvedBy: "Approuvé par {approver} le {date}",awaitingApproval: "En attente d\'approbation",close: "Fermer",exportPdf: "Exporter PDF",edit: "Modifier"
    },
    bulk: {
      countSelected: "{count} sélectionné(s)",
      approve: "Approuver la sélection",
      approving: "Approbation...",
      approveResult: "{approved} approuvé(s), {skipped} ignoré(s)",
      approveFailed: "{failed} en échec",
      downloadPdf: "Télécharger PDF",cancel: "Annuler",
      downloading: "Génération des PDF...",success: "{count} journal(aux) téléchargé(s)",error: "Échec du téléchargement. Réessayez."
    },
    sections: {
      generalInfo: "Informations générales",
      siteConditions: "Conditions du chantier",
      crew: "Équipe sur site",
      workPerformed: "Travaux effectués",
      materialsDelivered: "Matériaux livrés",
      issues: "Enjeux",
      notes: "Notes générales",
      photos: "Photos"
    },
    preview: {
      noSubcontractor: "Aucun sous-traitant",
      noIssue: "Aucun enjeu",
      noPhoto: "Aucune photo",
      subcontractors: "sous-traitants",
      workers: "ouvriers",
      tasks: "tâches"
    },
    picker: {
      empty: "Aucun sous-traitant dans le répertoire du projet",
      addToRepertoire: "+ Ajouter au répertoire du projet"
    },
    status: {
      draft: "Brouillon",
      submitted: "Soumis",
      approved: "Approuvé"
    },
    carriedFromPrevious: "reprises du journal précédent",
    previousPercent: "Précédent: {n}%",
    cannotReduce: "Impossible de réduire l'avancement. Minimum: {n}%",
    taskCompleted: "Complété",
    locked: {
      task: "Tâche verrouillée (avancement en cours)",
      subcontractor: "Sous-traitant verrouillé (avancement en cours)"
    },
    validation: {
      title: "Impossible d\'enregistrer",
      errorTitle: "Impossible d\'enregistrer",
      noTask: "{subName}: doit avoir au moins 1 tâche",
      invalidPct: "{subName} → {taskName}: pourcentage invalide",
      close: "Fermer",
      goToTask: "Aller à la tâche"
    }
  },
  brain: {
    title: "Brain",
    subtitle: "Ce qui mérite votre attention aujourd'hui.",
    selectorLabel: "Projet",
    selectorPlaceholder: "Tous les projets…",
    kpiSignals: "Signaux",
    kpiCritical: "Critiques",
    kpiExposed: "Argent exposé",
    kpiSites: "Chantiers touchés",
    empty: "Rien à signaler.",
    blindTitle: "Ce que Brain ne peut pas évaluer",
    columns: {
      finances: "Finances",
      financesSub: "budget, contrats, extras, crédits",
      legal: "Légal",
      legalSub: "ce qui doit être signé",
      documents: "Documents",
      documentsSub: "ce qui doit être produit, rempli ou fermé"
    },
    expand: "Élargir",
    collapse: "Réduire",
    pathTitle: "Le chemin",
    whyTitle: "Pourquoi ça compte",
    steps: {
      budgetLine: "Voir le poste budgétaire",
      contract: "Voir le contrat",
      contracts: "Voir les contrats",
      project: "Voir le projet",
      dailyLog: "Voir le journal de chantier",
      extras: "Voir les extras & crédits",
      changeOrders: "Voir les avenants",
      subInvoices: "Voir la facturation sous-traitants",
      denonciation: "Voir la dénonciation",
      quittances: "Voir les quittances",
      clientInvoices: "Voir la facturation client"
    },
    themes: {
      money: "Argent",
      legal: "Légal",
      engage: "Engagement",
      field: "Terrain"
    },
    signals: {
      stalled_long: "{task} est à {pct} % depuis {days} jours. {company} n'a rien changé sur {logs} journaux consécutifs.",
      near_complete_stalled: "{task} est à {pct} % — presque terminée — et n'a pas bougé depuis {days} jours. Ce qui vient après attend.",
      stalled: "{task} n'a pas avancé sur {logs} journaux. Dernier mouvement le {date}.",
      never_captured: "Ce chantier est ouvert depuis {expected} jours ouvrables et ne contient aucun journal. S'il y a une réclamation, rien ne prouve ce qui s'est passé.",
      low_coverage: "{logs} journaux pour {expected} jours ouvrables — {pct} % du chantier est documenté. {missing} journées n'ont laissé aucune trace.",
      partial_coverage: "{pct} % des jours ouvrables sont documentés. Il manque {missing} journées.",
      invoiced_no_co: "{amount} sont approuvés pour paiement sur cet extra et aucun avenant n'existe. Rien n'est opposable si le sous-traitant conteste.",
      invoiced_no_co_unapproved: "{amount} sont facturés sur un extra qui n'a jamais été approuvé, et aucun avenant n'existe.",
      co_unsigned: "{amount} facturés. L'avenant existe mais personne ne l'a signé.",
      co_draft: "{amount} facturés. L'avenant est resté en brouillon — personne ne l'a envoyé signer.",
      co_sent: "{amount} facturés. L'avenant est parti pour signature et n'est pas revenu.",
      unassigned_site_running: "{poste} est budgété à {budget} et n'a aucun sous-traitant. Le chantier roule depuis {days} jours.",
      unassigned_site_started: "{poste} est budgété à {budget} et n'a aucun sous-traitant. Le chantier vient de démarrer.",
      unassigned_site_imminent: "{poste} est budgété à {budget} et n'a aucun sous-traitant. Le chantier démarre dans {daysUntil} jours.",
      unsigned_awaiting_signature_long: "{company} attend la signature depuis {daysContract} jours. Le chantier est ouvert depuis {daysSite} jours.",
      unsigned_contract_stale: "{company} a reçu ce contrat il y a {daysContract} jours. Toujours pas signé.",
      unsigned_site_long_running: "Le chantier roule depuis {daysSite} jours et le contrat de {company} n'est pas fermé.",
      unsigned_site_running: "Le contrat de {company} n'est pas signé. Chantier ouvert depuis {daysSite} jours.",
      unsigned_site_started: "Le contrat de {company} n'est pas encore signé et le chantier vient de démarrer.",
      over_budget_preventable: "{company} est octroyé à {value} pour un poste budgété à {budget} — {pct} %. Le contrat n'est pas signé : ce montant mérite un deuxième regard.",
      over_budget_committed_large: "{company} a été signé à {value} pour un poste budgété à {budget}. {overage} de plus que prévu, déjà engagés.",
      over_budget_committed: "{company} dépasse son poste de {overage} — {pct} % du budget.",
      over_budget_marginal: "{company} dépasse légèrement son poste, de {overage}.",
      tm_no_budget_ceiling: "{companies} travaille en temps & matériel sur {poste}, qui n'a aucun budget. Il n'existe aucun plafond contre lequel mesurer la dépense.",
      tm_budget_exceeded: "Le budget {poste} est dépassé. {companies} y travaille en temps & matériel — le poste est entre {pctMin} % et {pctMax} % de son budget.",
      tm_budget_at_risk: "{poste} peut atteindre {pctMax} % de son budget. {companies} y travaille en temps & matériel, sans plafond contractuel.",
      tm_budget_approaching: "{poste} approche de son budget — jusqu'à {pctMax} %. {companies} y travaille en temps & matériel.",
      tm_under_watch: "{companies} travaille en temps & matériel sur {poste}. Le poste est à {pctMax} % de son budget de {budget}. Surveillance active jusqu'à la quittance finale.",
      paid_unreleased_denounced: "{uncovered} ont été versés à {company} sans quittance signée, et une dénonciation existe déjà sur ce contrat.",
      paid_unreleased_large: "{uncovered} ont été versés à {company} sans qu'aucune quittance ne soit revenue.",
      paid_unreleased: "{uncovered} versés à {company}, aucune quittance au dossier.",
      paid_unreleased_small: "{uncovered} versés à {company} sans quittance. Petit montant, mais le dossier reste ouvert.",
      released_without_payment: "Une quittance de {released} est signée pour {company}, alors qu'aucun paiement n'a été enregistré.",
      approved_before_client_payment: "Facture approuvée avant paiement client : DP-{dp} · {status} · {amount}."
    },
    silence: {
      not_enough_logs: "Pas assez de journaux sur ce chantier pour établir un rythme.",
      not_started: "Le chantier n'a pas encore commencé.",
      no_working_days: "Aucun jour ouvrable écoulé.",
      no_start_date: "Aucune date de début n'est inscrite.",
      site_not_started: "Le chantier n'a pas commencé — un contrat non signé est normal.",
      no_budget_line: "Ce contrat n'est rattaché à aucun poste budgétaire.",
      no_budget_amount: "Le poste budgétaire n'a aucun montant.",
      no_contract_value: "Le contrat n'a aucune valeur inscrite.",
      final_quittance_signed: "La quittance finale est signée — la surveillance est levée.",
      no_ceiling: "Aucun budget sur ce poste : il n'existe aucun plafond.",
      budget_fully_committed: "Le budget est déjà entièrement engagé par contrat.",
      nothing_paid: "Rien n'a été versé à ce sous-traitant — il n'y a rien à décharger.",
      fully_released: "Tout ce qui a été versé est couvert par une quittance signée."
    },
    why: {
      stalled_long: "Une tâche qui traîne depuis des semaines n'est plus un oubli, c'est un engagement que personne n'a repris. Plus elle vieillit, moins le sous-traitant se souvient de ce qui avait été convenu.",
      near_complete_stalled: "Une tâche presque finie qui ne bouge plus coûte souvent moins de deux heures de travail. C'est le type de reste qui retarde une réception de chantier pour une broutille.",
      stalled: "Une tâche sans mouvement depuis plusieurs jours signale soit un blocage que personne n'a nommé, soit un travail que le terrain a réglé sans le fermer. Les deux se corrigent avec une question au surintendant.",
      never_captured: "Un chantier sans journal ne laisse aucune trace de ce qui s'est passé. Le jour où un retard ou un dommage est contesté, il ne reste que la parole de chacun.",
      low_coverage: "Quelques journaux sur plusieurs semaines ne suffisent pas à reconstituer une séquence de travaux. Une réclamation se défend avec des jours consécutifs, pas avec des échantillons.",
      partial_coverage: "Les journées manquantes sont presque toujours celles où quelque chose d'anormal est arrivé. Combler les trous pendant que le terrain s'en souvient coûte quelques minutes; le faire six mois plus tard est impossible.",
      invoiced_no_co: "Un extra facturé sans avenant est un travail que le client n'a jamais formellement autorisé à ce prix. C'est la première somme qu'un client conteste, et celle qu'on défend le plus mal.",
      invoiced_no_co_unapproved: "L'avenant existe mais personne ne l'a approuvé : la facture part appuyée sur un document sans valeur. Tant que l'approbation manque, le montant reste une demande, pas une créance.",
      co_unsigned: "Un avenant approuvé mais non signé n'engage encore personne. La signature est ce qui transforme une entente verbale en montant recouvrable.",
      co_draft: "Un avenant resté en brouillon n'a jamais quitté ton bureau. Le client ignore encore que ce montant s'ajoute à son contrat, et plus l'écart s'allonge, plus l'annonce passe mal.",
      co_sent: "Un avenant envoyé sans retour est un silence, pas un accord. Relancer maintenant coûte un courriel; attendre la fin du projet coûte une négociation.",
      unassigned_site_running: "Des dépenses sans ligne de budget ne remontent nulle part : le projet paraît rentable parce qu'une partie du coût est invisible. Sur un chantier en cours, l'écart grossit chaque semaine.",
      unassigned_site_started: "Le chantier vient de démarrer et des montants circulent déjà hors budget. C'est le moment le moins cher pour les rattacher — après, personne ne se souvient à quoi ils appartenaient.",
      unassigned_site_imminent: "Des engagements sont pris avant même le début des travaux, sans point d'ancrage au budget. Partir avec un budget incomplet, c'est mesurer la rentabilité contre une cible fausse.",
      unsigned_awaiting_signature_long: "Un contrat en attente de signature depuis longtemps signale une hésitation que personne n'a traitée. Le sous-traitant travaille peut-être déjà, sans prix ni obligations opposables.",
      unsigned_contract_stale: "Un contrat resté sans signature pendant des semaines ne reflète souvent plus la réalité du chantier. Il faudra le rouvrir avant de le signer, et la renégociation se fait alors en position de faiblesse.",
      unsigned_site_long_running: "Le chantier avance depuis longtemps sans contrat signé. Chaque semaine de travail exécuté sans document rend une contestation de prix ou d'étendue plus difficile à trancher.",
      unsigned_site_running: "Le sous-traitant est sur le chantier et rien n'est signé. En cas de défaut, de dommage ou de retard, tu n'as aucun texte à lui opposer.",
      unsigned_site_started: "Les travaux viennent de commencer sans signature. C'est la dernière fenêtre où le sous-traitant signe sans discuter, parce qu'il n'a encore rien à perdre.",
      over_budget_preventable: "Le dépassement n'est pas encore consommé : il reste de la marge pour le corriger. Une fois les travaux exécutés, il ne reste qu'à le constater.",
      over_budget_committed_large: "Un dépassement important est déjà engagé par contrat. Ce montant ne se récupère plus au chantier — seulement par un avenant client, s'il est justifiable.",
      over_budget_committed: "L'engagement dépasse le budget : la perte est déjà décidée, même si elle n'est pas encore facturée. La signaler tôt permet de la compenser ailleurs dans le projet.",
      over_budget_marginal: "L'écart est faible mais réel. Sur un projet, cinq écarts marginaux valent un dépassement majeur, et aucun n'a été discuté.",
      tm_no_budget_ceiling: "Des travaux en régie sans plafond n'ont aucune limite naturelle : le coût suit les heures, pas une entente. Le plafond est le seul outil pour arrêter la dérive avant la facture.",
      tm_budget_exceeded: "Le plafond convenu est dépassé et les heures continuent. Tout ce qui s'ajoute maintenant se facture sans couverture, à moins d'un accord écrit.",
      tm_budget_at_risk: "La régie approche du plafond alors que les travaux ne sont pas terminés. C'est le dernier moment pour renégocier avant de dépenser sans autorisation.",
      tm_budget_approaching: "La consommation approche du plafond. Aviser le client maintenant fait partie de l'entente; l'aviser après le dépassement ressemble à une facture surprise.",
      tm_under_watch: "La régie progresse normalement, mais elle mérite un œil. Les travaux en régie dérivent rarement d'un coup — ils dérivent une semaine à la fois.",
      paid_unreleased_denounced: "Une dénonciation transforme un risque théorique en risque nommé : quelqu'un s'est déjà déclaré. Sans quittance, rien ne prouve que l'argent versé a été redistribué, et une hypothèque légale peut suivre.",
      paid_unreleased_large: "L'argent est sorti. Si le sous-traitant ne paie pas ses propres fournisseurs, ceux-ci peuvent inscrire une hypothèque légale sur le bâtiment du client — et la compagnie paie une deuxième fois.",
      paid_unreleased: "La quittance est la seule preuve que le sous-traitant reconnaît avoir été payé. Sans elle, le versement n'existe que dans les relevés bancaires.",
      paid_unreleased_small: "Petit montant, mais le principe est le même : de l'argent est sorti sans contrepartie signée. C'est le genre de dossier qu'on oublie jusqu'au jour de la réclamation.",
      released_without_payment: "Une quittance porte un montant supérieur à ce qui a été versé. Le sous-traitant contestera, et il aura raison. Ce montant vient probablement du facturé approuvé plutôt que du payé.",
      approved_before_client_payment: "Le sous-traitant est approuvé pour paiement alors que le client n'a pas encore payé cette demande de paiement : la compagnie avance l'argent."
    }
  },
  quittances: {
    title: "Dénonciations & Quittances",
    subtitle: "Suivre les dénonciations et les quittances des sous-traitants",
    sidebarLabel: "Dénonciations & Quittances",
    tabs: {
      denonciations: "Dénonciations",
      quittances: "Quittances"
    },
    kpi: {
      subcontractors: "Sous-traitants",
      denounced: "Dénoncés",
      approvedToDate: "Facturation approuvée",
      balance: "Balance à quittancer",
      blocked: "Contrats bloqués",
    },
    toolbar: {
      searchPlaceholder: "Rechercher un sous-traitant...",
      filterAll: "Tous",
      filterNotified: "Dénoncés",
      filterNotNotified: "Non dénoncés",
      filterSettled: "Réglés",
      newDenonciation: "Nouvelle dénonciation",
      editDenonciation: "Modifier la dénonciation",
      subcontractLink: "Sous-traitant lié",
      subcontractLinkPlaceholder: "Sélectionner un sous-traitant...",
      intervenantName: "Intervenant",
      intervenantNamePlaceholder: "Nom de l'entreprise ou du fournisseur",
      supplierName: "Fournisseur",
      supplierNamePlaceholder: "Inscrire le nom du fournisseur",
      specialitePlaceholder: "ex. Électricité",
      typeLabel: "Qui dénonce ?",
      typePrincipal: "Sous-traitant",
      typeSecondaire: "Fournisseur du sous-traitant",
      typeOuverte: "Fourniture ouverte",
      contractContextLabel: "Contrat sélectionné",
      pricingFixed: "Contrat à forfait",
      pricingMaterialSupply: "Bon de commande — fourniture",
      pricingLaborMaterial: "Régie",
      noAmount: "sans montant",
      ouverteHint: "Fourniture ouverte — le montant peut être inconnu.",
      montantEstimeLabel: "Montant estimé",
      montantOptional: "(optionnel)",
      montantRequired: "Le montant dénoncé est requis pour une dénonciation à montant ferme.",
      lieAPlaceholder: "Avec qui le contrat est signé",
      lieALockedHint: "Raison sociale de votre organisation. Modifiable dans Paramètres > Organisation.",
      contractTargeted: "Contrat visé",
      contractTargetedPlaceholder: "Sélectionner le contrat du sous-traitant approvisionné...",
      contractRequired: "Le contrat est requis.",
      lieAFromContractHint: "Raison sociale du contrat sélectionné. Se met à jour avec le contrat.",
      dateLabel: "Date de dénonciation",
      montantLabel: "Montant dénoncé",
      notesLabel: "Notes",
      notesPlaceholder: "Optionnel",
      docsLabel: "Documents",
      docsNone: "Aucun document",
      docsAdd: "Joindre un document",
      docsOpen: "Ouvrir le document",
      docsRemove: "Retirer le document",
      docsRemoveTitle: "Retirer le document",
      docsRemoveMessage: "Ce document sera définitivement supprimé.",
      docsAdded: "Document joint",
      docsRemoved: "Document retiré",
      docsPendingHint: "{count} fichier(s) en attente — ils seront téléversés à l'enregistrement.",
      docsUploadFailed: "Dénonciation enregistrée, mais ces fichiers n'ont pas pu être téléversés : {names}",
      lettreLabel: "Lettre de dénonciation",
      lettreHint: "PDF, JPG ou PNG — max 10 Mo",
      lettreChoose: "Choisir un fichier",
      lettreReplace: "Remplacer",
      lettreRemove: "Retirer",
      lettreNone: "Aucune lettre",
      lettreOpen: "Ouvrir la lettre",
      lettreInvalidType: "Format non supporté. Utilisez PDF, JPG ou PNG.",
      lettreTooLarge: "Fichier trop volumineux (max 10 Mo).",
      lettreUploadFailed: "La dénonciation est enregistrée, mais la lettre n'a pas pu être téléversée.",
      save: "Enregistrer",
      required: "Le nom de l'intervenant est requis.",
      createdToast: "Dénonciation ajoutée",
      updatedToast: "Dénonciation modifiée",
      deletedToast: "Dénonciation supprimée",
      errorToast: "Une erreur est survenue. Veuillez réessayer.",
      deleteTitle: "Supprimer la dénonciation",
      deleteMessage: "Cette dénonciation sera définitivement supprimée.",
      deleteChecking: "Vérification des liens…",
      deleteBlockedTitle: "Suppression impossible",
      deleteBlockedMessage: "Cette dénonciation est couverte par une quittance. Retirez d'abord la quittance pour pouvoir la supprimer.",
      deleteBlockedClose: "Fermer",
      blockedQuittances: "{count} quittance(s)",
      deleteAlsoRemoves: "{count} document(s) joint(s) seront également supprimés.",
      edit: "Modifier",
      delete: "Supprimer",
      actions: "Actions"
    },
    table: {
      subcontractor: "Sous-traitant",
      dateDenonciation: "Date dénonciation",
      notNotified: "— non dénoncé",
      revised: "Montant révisé",
      balance: "Balance",
      status: "Statut",
      dp: "Quittance DP{number}",
      noDp: "Sans DP",
      taxIncl: "taxe incluse",
      beforeTax: "avant taxes",
      cumulative: "cumulatif",
      toRelease: "à quittancer",
      released: "quittancé",
      planned: "à prévoir",
      cumulAboveRelease: "Cumul supérieur à la quittance signée",
      remaining: "ce qui reste",
      laborMaterial: "Régie",
      letter: "Lettre jointe",
      details: {
        paidInvoices: "Factures payées",
        approvedInvoices: "Factures approuvées",
        previousDps: "Déjà couvert par DP{from}–DP{to}",
        previousDp: "Déjà couvert par DP{number}",
        remaining: "reste {remaining} sur {total}",
        noNumber: "Sans numéro",
        total: "Total"
      }
    },
    status: {
      toNotify: "À dénoncer",
      partial: "Partielle",
      settled: "Réglé",
      settledFinale: "Réglé — finale émise",
      finaleUnbalanced: "Finale émise — solde non nul",
    },
    emit: {
      column: "Quittances",
      chipNumbered: "Quittance {number}",
      dpOption: "DP {number}",
      chipFinale: "Finale",
      action: "Émettre",
      title: "Émettre une quittance",
      dpLabel: "Demande de paiement",
      typeLabel: "Type de quittance",
      type: {
        partielle: "Partielle",
        finale: "Finale"
      },
      amountLabel: "Montant (taxes incl.)",
      issuerLabel: "Qui émet cette quittance ?",
      issuerSubcontractor: "{name} — sous-traitant",
      issuerSupplier: "{name} — fournisseur dénoncé",
      supplierRecap: "Dénoncé {denounced} · déjà quittancé {released} · reste {remaining}",
      supplierAmountRequired: "Inscrivez le montant de la quittance reçue.",
      amountRequired: "Aucune facture approuvée à quittancer pour cette sélection.",
      amountFromDp: "Cumul payé jusqu'à la DP {number}",
      amountFromAll: "Total payé à ce jour, toutes DP confondues",
      dpNoNewInvoice: "Aucune nouvelle facture approuvée sur cette période.",
      finaleNeedsBalance: "Il reste {amount} non facturés. Facturez le solde, ou émettez un avenant de crédit pour ramener le contrat au montant réel.",
      balanceUnverifiable: "Contrat sans montant de référence — le solde n'est pas vérifiable.",
      finaleLocksDp: "Finale — solde tout le contrat, rattachée à la DP choisie",
      linkedToNotice: "Rattachée à la dénonciation du {date}",
      linkedToNoticeNoDate: "Rattachée à la dénonciation de ce contrat",
      dateLabel: "Date de la quittance",
      legalNotice: "Joignez la quittance signée par le sous-traitant. OnsitePM ne génère aucun formulaire : utilisez le vôtre.",
      confirm: "Enregistrer la quittance",
      dupDp: "Une quittance existe déjà pour ce sous-traitant et cette demande de paiement.",
      dupFinale: "Une quittance finale a déjà été émise pour ce sous-traitant.",
      dupFinaleSupplier: "Une quittance finale a déjà été enregistrée pour ce fournisseur.",
      openExisting: "Ouvrir la quittance existante",
      dpCovered: "Quittance reçue",
      createdToast: "Quittance enregistrée",
      deletedToast: "Quittance supprimée",
      deleteTitle: "Supprimer cette quittance ?",
      deleteMessage: "La quittance sera définitivement retirée du dossier. Cette action est irréversible."
    },
    exposure: {
      title: "Fournisseurs dénoncés sous ce contrat",
      explain: "Payer ce sous-traitant sans détenir la quittance de ses fournisseurs expose le chantier à une hypothèque légale de leur part.",
      denounced: "Dénoncé",
      released: "Quittancé",
      unknownAmount: "montant inconnu",
      seeNotice: "Voir la dénonciation",
      markerTooltip: "{name} — dénoncé {denounced}, reste {remaining}",
      status: {
        uncovered: "Non quittancé",
        partial: "Partiel",
        covered: "Quittancé"
      }
    },
    supplier: {
      savedButUploadFailed: "Quittance enregistrée, mais le fichier {name} n'a pas pu être téléversé."
    },
    signed: {
      title: "Quittance signée",
      attach: "Joindre la quittance signée",
      present: "Quittance signée jointe — cliquer pour l'ouvrir ou la remplacer",
      hint: "PDF, JPG ou PNG · 10 Mo max · un seul fichier",
      replaceHint: "Une seule quittance signée par émission. Pour la remplacer, retirez le fichier actuel puis déposez le nouveau.",
      uploadedToast: "Quittance signée jointe",
      removedToast: "Quittance signée retirée",
      removeTitle: "Retirer la quittance signée ?",
      removeMessage: "Le fichier signé sera détaché de cette quittance. La quittance elle-même est conservée."
    },
    denonciations: {
      intervenant: "Intervenant",
      specialite: "Spécialité",
      lieA: "Contrat avec",
      date: "Date dénonciation",
      montant: "Montant dénoncé",
      letter: "Lettre",
      principal: "Principal",
      secondaire: "Secondaire",
      estime: "estimé",
      empty: "Aucune dénonciation",
      emptyHint: "Les dénonciations reçues pour ce projet apparaîtront ici."
    },
    empty: {
      noSubcontracts: "Aucun contrat",
      noSubcontractsHint: "Ajoutez des contrats à ce projet pour suivre les quittances."
    }
  },
  rfi: {
    saved: "QRT enregistré",
    deleted: "QRT supprimé",
    deleteFailed: "Le QRT n'a pas pu être supprimé.",
    saveFailed: "Le QRT n'a pas été enregistré. Réessayez.",
    deleteLocked: "Un QRT répondu ne peut pas être supprimé.",
    viewTitle: "Consulter le QRT",
    editTitle: "Modifier le QRT",
    deleteDialog: {
      title: "Supprimer le QRT",
      message: "Êtes-vous sûr de vouloir supprimer ce QRT ? Cette action est irréversible.",
      delete: "Supprimer",
      cancel: "Annuler"
    },
    actions: {
      view: "Consulter",
      downloadPdf: "Télécharger le PDF",
      delete: "Supprimer",
      respond: "Répondre"
    },
    status: {
      draft: "Créé",
      sent_for_approval: "Envoyé pour approbation",
      answered: "Répondu",
      in_review: "En révision"
    },
    qrt: {
      title: "Réponse au QRT {number}",
      warning: "Une fois soumis, ce QRT sera marqué comme répondu.",
      editWarning: "Cette réponse sera remplacée. Il n\'y a qu\'une seule réponse par QRT, sans historique.",
      responsePdfOptional: "PDF de la réponse",
      pdfAttachedDocument: "Document joint",
      minCharacters: "Minimum 10 caractères requis.",
      photosDropzone: "Cliquer pour ajouter des photos",
      photosFormats: "JPEG, PNG, WebP",
      submitting: "Soumission...",
      errorFallback: "Échec de l'envoi de la réponse.",
      pdfDropzone: "Glisser-déposer ou cliquer pour téléverser",
      pdfDropzoneHint: "PDF uniquement · max 50 MB",
      pdfReplaceDropzone: "Glisser-déposer ou cliquer pour remplacer le document",
      pdfReplaceHelper: "Le document actuel sera remplacé.",
      responseText: "Texte de la réponse",
      responseTextPlaceholder: "Copier la réponse reçue par courriel...",
      responsePdf: "PDF de la réponse (obligatoire)",
      responsePhotos: "Photos de la réponse (optionnel)",
      submit: "Soumettre la réponse",
      cancel: "Annuler",
      success: "Réponse soumise avec succès",
      errorPrefix: "Erreur lors de la soumission"
    },
    pageTitle: "QRT",
    editResponse: "Modifier la réponse",
    locked: "Verrouillée",
    question: "Question",
    response: "Réponse",
    answeredAt: "Répondu le",
    downloadResponsePdf: "Télécharger le PDF de réponse",
    statusUpdated: "Statut mis à jour",
    subtitle: "Gérer et suivre les demandes d'information",
    professions: {
      architect: "Architecte",
      mechanical: "Mécanique",
      electrical: "Électricité",
      structural: "Structure",
      civil: "Génie civil",
      plumbing: "Plomberie",
      generalContractor: "Entrepreneur général",
      owner: "Propriétaire",
      other: "Autre"
    },
    kpi: {
      totalRfis: "Total"
    },
    toolbar: {
      searchPlaceholder: "Rechercher un QRT...",
      filterAll: "Tous",
      newRfi: "Nouveau QRT"
    },
    table: {
      number: "QRT n°",
      subject: "Sujet",
      profession: "Profession",
      photos: "Photos",
      status: "Statut",
      date: "Date",
      actions: "Actions"
    },
    empty: {
      noRfis: "Aucun QRT trouvé",
      createFirst: "Créez votre premier QRT pour commencer",
      noneOpen: "Aucun QRT ouvert ✓"
    },
    create: {
      title: "Nouveau QRT",
      subtitle: "Demande d'information",
      subjectLabel: "Sujet",
      subjectPlaceholder: "ex. Clarification sur les dimensions de la poutre",
      professionLabel: "Profession",
      professionPlaceholder: "Sélectionner une profession...",
      questionLabel: "Question",
      questionPlaceholder: "Décrivez votre question ou votre demande en détail...",
      photosLabel: "Photos",
      uploadHint: "Cliquez pour téléverser des photos",
      uploadFormats: "JPEG et PNG seulement",
      photoPreviewAlt: "Aperçu {index}",
      submit: "Créer le QRT",
      submitting: "Création...",
      subjectRequired: "Le sujet est requis.",
      createFailed: "Échec de la création du QRT."
    },
    detail: {
      professionLabel: "Profession",
      dateLabel: "Date",
      statusLabel: "Statut",
      photosCount: "Photos ({count})",
      responsePhotoAlt: "Photo de réponse {index}",
      generatePdf: "Générer le PDF",
      generatingPdf: "Génération...",
      noPhotos: "Aucune photo jointe",
      photoDeleteFailed: "La photo n'a pas pu être supprimée."
    }
  },
  projectSchedule: {
    title: "Calendrier des projets",
    today: "Aujourd\'hui",
    subtitle: "Vue chronologique de tous les projets actifs",
    granularity: {
      day: "Jour",
      week: "Semaine",
      month: "Mois",
      quarter: "Trimestre"
    },
    nav: {
      today: "Aujourd\'hui"
    },
    filter: {
      allPMs: "Tous les CP"
    },
    legend: {
      title: "Chargés de projet"
    },
    empty: "Aucun projet actif à afficher",
    tooltip: {
      pm: "CP",
      duration: "Durée",
      days: "jours",
      value: "Valeur du contrat",
      status: "Statut"
    }
  },
  orgSettings: {
    pageTitle: "Paramètres de l\'organisation",
    pageSubtitle: "Gérez la configuration de votre organisation.",
    navLabel: "Paramètres org.",
    accessDenied: {
      title: "Accès administrateur requis",
      message: "Cette page est réservée aux administrateurs.",
      goHome: "Aller au tableau de bord"
    },
    templates: {
      sectionTitle: "Gabarits de permissions",
      sectionSubtitle: "Chaque gabarit décide quelles pages ses porteurs peuvent ouvrir.",
      templateCount: "gabarit(s)",
      systemBadge: "Système",
      usersCount: "{count} utilisateur(s)",
      noneYet: "Aucun gabarit pour l\'instant.",
      nameLabel: "Nom du gabarit",
      namePlaceholder: "ex. Chargé de projet",
      nameRequired: "Le nom est requis.",
      newTemplate: "Nouveau gabarit",
      duplicate: "Dupliquer",
      duplicateSuffix: "{name} (copie)",
      rename: "Renommer",
      delete: "Supprimer",
      save: "Enregistrer",
      saved: "Gabarit enregistré",
      created: "Gabarit créé",
      deleted: "Gabarit supprimé",
      cancel: "Annuler",
      edit: "Modifier",
      selectAll: "Tout cocher",
      selectNone: "Tout décocher",
      reset: "Réinitialiser",
      resetConfirmTitle: "Réinitialiser ce gabarit ?",
      resetConfirmMessage: "« {name} » retrouvera sa configuration d\'origine. Les modifications faites depuis seront perdues.",
      resetDone: "Gabarit réinitialisé",
      groupApp: "Pages générales",
      groupProject: "Pages de projet",
      upcoming: "à venir",
      hiddenPage: "atteinte depuis une autre page",
      systemEditable: "Les gabarits système se modifient, mais ne se suppriment pas. Chaque organisation a ses propres copies.",
      deleteConfirmTitle: "Supprimer ce gabarit ?",
      deleteConfirmMessage: "« {name} » sera supprimé définitivement.",
      blocked: {
        system_template: "Un gabarit système ne peut pas être supprimé. Vous pouvez le modifier.",
        in_use: "« {name} » est encore attribué à {count} utilisateur(s). Réattribuez-les avant de le supprimer.",
        last_admin_users_page: "Impossible : ce gabarit est celui du dernier administrateur actif. Retirer « Utilisateurs » lui fermerait la gestion des accès, sans retour possible."
      },
      error: "L\'opération a échoué. Réessayez.",
      pages: {
        appProjectList: "Liste des projets",
        appSchedule: "Calendrier des projets",
        appDirectory: "Répertoire",
        appInvoiceInbox: "Boîte des factures",
        appProjectView: "Vue d\'ensemble",
        appBrain: "Brain",
        appOnx: "OnX (Assistant IA)",
        appMargin: "Marge",
        appUsers: "Utilisateurs",
        appOrgSettings: "Paramètres de l\'organisation",
        projectDirectory: "Répertoire du projet",
        projectDocuments: "Documents",
        projectSchedule: "Calendrier",
        projectDailyLog: "Journal de chantier",
        projectRfi: "QRT",
        projectBudget: "Aperçu financier",
        projectContracts: "Contrats",
        projectExtras: "Directives & Extras",
        projectChangeOrders: "Avenants",
        projectExpenses: "Dépenses",
        projectSubInvoices: "Factures reçues",
        projectSubInvoiceApprove: "Approbation de facture",
        projectClientInvoices: "Facturation client",
        projectQuittances: "Dénonciations & Quittances"
      }
    },
    trades: {
      sectionTitle: "Corps de métier",
      sectionSubtitle: "Configurez la liste des corps de métier disponibles lors de la création de sous-traitants.",
      activeCount: "actif(s)",
      addPlaceholder: "Nom du nouveau corps de métier...",
      active: "Actif",
      inactive: "Inactif",
      activate: "Activer",
      deactivate: "Désactiver",
      moveUp: "Monter",
      moveDown: "Descendre",
      empty: "Aucun corps de métier configuré.",
      loadError: "Impossible de charger les corps de métier.",
      writeError: "Impossible d'enregistrer les modifications. Vous n'avez peut-être pas les droits administrateur.",
      retry: "Réessayer",
      deleteConfirmTitle: "Supprimer le corps de métier",
      deleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer « {name} » ? Cette action est irréversible."
    }
  },
  project360: {
    title: "Vue d'ensemble",
    subtitle: "Vue d'ensemble d'un projet — rentabilité, facturation et coûts.",
    selectorLabel: "Projet",
    selectorPlaceholder: "Sélectionner un projet…",
    breadcrumbPortfolio: "Portefeuille",
    anchorProfitParDp: "Profit par DP",
    kpiContrat: "Contrat",
    kpiBilled: "Travaux facturés",
    kpiCosts: "Coûts",
    kpiMargin: "Marge $",
    kpiMarginPct: "Marge %",
    teamPm: "CP",
    teamSupervisor: "Surint.",
    teamCoordinator: "Coord.",
    cardProfitParDp: "Profit par demande de paiement",
    cardFacturation: "Facturation & retenues",
    cardFacturesST: "Factures ST à payer",
    anchorFacturation: "Facturation & retenues",
    anchorFacturesST: "Factures ST à payer",
    statusApproved: "Approuvé",
    statusSubmitted: "Soumis",
    statusDraft: "Brouillon",
    noDps: "Aucune demande de paiement trouvée.",
    unassignedNote: "Coûts non attribués à une DP : {amount}",
    noData: "Projet introuvable.",
    enAttenteApprobation: "En attente d\'approbation",
    retenueAccumulee: "Retenue accumulée",
    colDp: "DP",
    colSousTotal: "Sous-total",
    colFacture: "Facturé",
    colRetenue: "Retenue",
    colStatut: "Statut",
    colSousTraitant: "Sous-traitant",
    colSolde: "Solde",
    colAge: "Âge",
    totalDu: "Total dû",
    noOutstandingST: "Aucune facture ST en attente.",
    moreDetails: "Plus de détails →",
    refreshedAt: "Actualisé à {time}",
    refreshBtn: "↻ Actualiser",
    notesTitle: "Notes",
    notesPlaceholder: "Ajouter une note…",
    notesAdd: "Ajouter",
    notesEmpty: "Aucune note."
  },
  portfolioProfitability: {
    title: "Rentabilité du portefeuille",
    subtitle: "Aperçu des revenus, coûts et marges à travers tous les projets.",
    filterAll: "Tous",
    filterActive: "Actifs seulement",
    kpiContract: "Contrat total",
    kpiBilled: "Facturé (client)",
    kpiCosts: "Coûts liés",
    kpiMarginAmt: "Marge $",
    kpiMarginPct: "Marge %",
    chartTitle: "Marge % par projet",
    colProject: "Projet",
    colStatus: "Statut",
    colContract: "Contrat",
    colBilledCosts: "Facturé / Coûts",
    colBilled: "Facturé",
    colCosts: "Coûts",
    colMarginAmt: "Marge $",
    colMarginPct: "Marge %",
    total: "Total",
    legendBilled: "Facturé (client)",
    legendCosts: "Coûts",
    unassignedNote: "Coûts non attribués à une DP : {amount}",
    noData: "Aucun projet trouvé."
  },
  onx: {
    greeting: "Salut! 👋 Comment puis-je t'aider aujourd'hui?",
    placeholder: "Écris à OnX...",
    newChat: "Nouveau chat",
    online: "En ligne",
    subtitle: "Assistant IA · OnSiteX",
    typing: "OnX réfléchit...",
    comingSoon: "Bientôt disponible",
    errorGeneric: "Une erreur est survenue. Réessaie.",
    send: "Envoyer"
  },
  pilot: {
    title: "Pilot",
    emptyTitle: "Posez une question sur votre projet",
    emptyTitleGlobal: "Posez une question sur vos projets",
    emptySubtitle: "Pilot interroge vos données en temps réel.",
    emptySubtitleGlobal: "Pilot peut chercher dans tous vos projets autorisés.",
    inputPlaceholder: "Posez une question…",
    noProject: "Sélectionnez un projet pour utiliser Pilot.",
    errorGeneric: "Une erreur est survenue. Réessayez.",
    toolsUsed: "Données consultées",
    newConversation: "Nouvelle conversation",
    contextOrg: "Contexte organisationnel"
  }
};
